// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_PlRt2 {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.container_oi96Q {
  display: flex;
  height: 93vh;
  margin: 0;
  padding: 0;
  /* background-color: var(--white-background); */
  font-family: "Inter", serif;
  position: relative;
}

/* .asideBar {
  background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);
  height: 0px;
  box-sizing: border-box;
  top: 0;
  z-index: 2;
  transition: left 0.3s ease;
  -webkit-transition: left 0.3s ease;
  -moz-transition: left 0.3s ease;
  -ms-transition: left 0.3s ease;
  -o-transition: left 0.3s ease;
  position: initial;
  left: 0;
  flex: 20;
  padding: 0px 6px;
} */

/* .mobileMenu {
  position: absolute;
  width: 100vw;
} */

.offAsideBar_qtpQU {
  left: -100%;
}

.chatSection_oQ4R_ {
  display: flex;
  align-items: flex-start;
  height: 100vh;
  width: 100%;
  background: var(--f5-background);
}

.inputContainer_EzQsp {
  width: 100%;

  input[type="file"] {
    display: none;
  }

  label {
    height: 100%;
    width: 100%;
    color: var(--_646e8a-color);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.footerChat_G4Zrl {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  margin: 10px 0;

  span {
    cursor: pointer;
  }

}

.languageContainer_Dhegf {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--_16c098-color);
  flex-wrap: wrap;
}

.linksContainerFooterChat_u2H3x {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  a {
    color: var(--_9b-color);
  }
}

.chatContainer_p8g34 {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  /* background: var(--f5-chatAdmin-background); */
  /* border-radius: 20px; */

  ul {
    list-style-type: disc;
    max-height: 100px;
    overflow-y: scroll;
    width: 100%;
    padding-left: 10px;
  }

  .messageContainer_wDfal::-webkit-scrollbar {
    display: none;
  }

  .messageContainer_wDfal {
    width: 80%;
    overflow-y: scroll;
    max-height: calc(100% - 190px);
    /* height: 70vh; */
    height: 100%;
    margin: 10px auto;
    display: grid;
    flex-direction: column;
    gap: 10px;
    display: flex;

    .messageSettings_Cs1Np {
      text-align: center;
      margin-top: 40px;
      color: var(--_6-color);
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }

    p {
      margin: 0;
    }

    .initialMessage_twsca {
      min-height: 60vh;
      align-items: center;
      display: flex;
      justify-content: center;
      flex-direction: column;

      h2 {
        margin: 0;
        color: var(--_2-color);
        text-align: center;
        font-family: Inter;
        font-size: clamp(20px, 5vw, 28px);
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        margin-top: 16px;
      }
    }

    .facturaGPTLogo_CzcwV {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;

      svg {
        width: 200px;
        stroke: var(--_10a37f-background);
      }
    }
  }

  .messageAutomateContainer_TwbDa {
    height: 100%;
  }

}

.chatContainerAgent_tZLtD {
  max-height: calc(100vh - 55px);
  margin: 0;
  padding: 0;
  overflow-y: clip;
  box-sizing: border-box;
}

.chatTextContainer_p2EU2 {
  width: 100%;
  bottom: 0px;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  /* background-color: var(--f5-chatAdmin-background); */
}

.chatTextContainerEnd_KLmG8 {
  justify-content: end;
}

.loading_mNDYt {
  display: none;
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 30px;
  width: 63%;
  height: 3px;
  background: linear-gradient(90deg,
      transparent 0%,
      var(--_16c098-background) 25%,
      var(--_16c098-background) 75%,
      transparent 100%);
  background-size: 200% 100%;
  animation: loading_mNDYt 2s infinite ease-in-out;
  opacity: 0.8;
  -webkit-animation: loading_mNDYt 2s infinite ease-in-out;

  &.active_ANY5I {
    display: block;
  }
}



@keyframes loading_mNDYt {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }


}

.infoChunck_YD29U {
  position: absolute;
  top: -30px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  >div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    background-color: var(--white-background);
    padding: 5px 12px;
    border-radius: 12px;
    box-shadow: 0 4px 10px -4px var(--_0000001a-shadow);

    span {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 10px;

      svg {
        width: 10px;
        height: 10px;
      }
    }
  }

  .upArrow_E67l3 {
    transform: rotate(-45deg);
    fill: var(--_8a-color);
  }

  .downArrow_CErUu {
    fill: var(--_8a-color);
    transform: rotate(135deg);
  }
}



.chatContainerBorderAnimation_YaDoq {
  border: 4px solid rgba(0, 255, 0, 1);
  animation: fadeBorder_dQAi_ 2s infinite;
}

.chatTextAreaContainer_EBubJ {
  width: 90%;
  max-width: 600px;
  background-color: var(--f4-chatAdmin-background);
  display: flex;
  position: relative;
  flex-direction: column;
  padding-right: 4px;
  margin: 0 auto;
  justify-content: center;
  border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  -webkit-border-radius: 20px;
  /* padding: 10px 20px; */
  padding: 10px 10px 4px;
  gap: 6px;
  box-sizing: border-box;

  border: 2px solid transparent;



  @media (width<=768px) {
    width: 80%;
  }

  .optionsChat_i3nml {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    position: relative;


    svg {
      fill: var(--_2-color);
      color: var(--_2-color);
    }

    .activeIcon_QFgur {
      fill: var(--_10a37f-background);
      color: var(--_10a37f-background);

    }

    >div {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    div>button:nth-of-type(2) {
      gap: 5px;
      border-radius: 30px;
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
    }

    div>button {
      cursor: pointer;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      outline: none;
      position: relative;
      border: 1px solid var(--_00000036-border);
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      min-width: 32px;
      height: 30px;
      font-weight: 500;
      background: var(--btn-chat-background);

      svg {
        fill: var(--_6-color);
        color: var(--_6-color);
      }

      &:hover {
        border: 1px solid var(--_10a37f-background);

        svg {
          fill: var(--_10a37f-background);
          color: var(--_10a37f-background);
        }
      }


      &::before {
        content: attr(data-tooltip);
        position: absolute;
        top: calc(120% + 2px);
        padding: 5px 10px;
        background: var(--_000000cc-background);
        color: var(--white-color);
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;

      }

      &::after {
        content: "";
        position: absolute;
        top: calc(100% - 2px);
        left: 50%;
        transform: translateX(-50%);
        border: 5px solid transparent;
        border-bottom-color: var(--_000000cc-background);
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease;
      }

      &:hover::before,
      &:hover::after {
        opacity: 1;
        visibility: visible;
      }

      svg,
      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  textarea::-webkit-scrollbar {
    display: none;
  }

  textarea {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: transparent;
    outline: none;
    border: none;
    resize: none;
    font-family: "Inter", serif;
    color: var(--black-color);
    font-size: 16px;
  }

  textarea::placeholder {
    font-family: "Inter", serif;
  }

  .restartButton_lOSBd {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: var(--_9b-color);
  }

  .sendMessageBtn_LdwVt {
    background-color: var(--_073f31-background);
    height: 40px;
    min-width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;
    outline: none;
    border: none;
  }

  .sendMessageBtn_LdwVt[disabled] {
    background: var(--_d7-background);
    cursor: not-allowed;
  }

  .ArrowUp_Ai_pO {
    fill: var(--_6-color);
    color: var(--_6-color);
  }

  .PauseIcon_T_xMC {
    fill: var(--e6fff9-background);
    color: var(--e6fff9-background);

  }
}

@keyframes fadeBorder_dQAi_ {
  0% {
    border-color: var(--_16c098-background);
  }

  50% {
    border-color: transparent;
  }

  100% {
    border-color: var(--_16c098-background);
  }
}

@keyframes rogBgImg_sSKSz {
  0% {
    transform: rotate(0deg);
    opacity: 1;
    scale: 1;

  }

  50% {
    opacity: 0;
    scale: 0;
  }

  100% {
    transform: rotate(180deg);
    opacity: 1;
    scale: 1;
  }
}

.errorAlert_zdTuP,
.loading_mNDYt {
  color: var(--_5d-color);
  font-size: 12px;
  text-align: center;

  a {
    color: var(--_073f31-color);
  }
}

.buttonContainer_AZB3h {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 10px;

  button {
    background-color: var(--white-background);
    color: var(--_67-color);
    border: 1px solid var(--_00000036-border);
    padding: 8px;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
  }
}

@media (max-width: 768px) {
  .buttonContainer_AZB3h {
    button {
      flex: 1 1;
      font-size: 10px;
      padding: 1px 6px;

      svg {
        height: 10px;
        min-width: 10px;
      }
    }
  }
}

.message_iTnk6 {
  display: inline-flex;
  align-items: flex-end;
  gap: 2px 14px;
  width: 90%;

  .avatar_JXw7N {
    min-width: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--_16c09821-background);
    color: var(--_16c098-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: 600;
  }

  .avatarBot_F9cma {
    min-width: 26px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    padding: 7px;
    background: var(--_0000000a-background);
  }
}

.isApp_dnxw0 {
  width: 100%;
  background: transparent !important;
  padding: 0px !important;
  display: inline-flex;
  flex-direction: column;
  gap: 10px;

  >p {
    font-size: 14px;
    /* background: var(--e6fff9-background); */
    background: linear-gradient(135deg, #10a37f 0%, #16c098 100%);
    padding: 10px;
    line-height: 20px;
    border-radius: 20px;
    color: #fff;
    flex-direction: column;
    &.appHint_uGyor {
      background: linear-gradient(135deg, #414443 0%, #000000 100%);
      border-radius: 20px 20px 0px 0px;
      margin-bottom: -33px;
      padding-bottom: 30px;
    }
  }
}

.isApi_RdCbJ {
  [class^="newTagHead"] {
    display: none;
  }

  [class^="container"] {
    position: relative;
    top: 0;
    left: 0;
    z-index: 0;
    transform: none;
    background: transparent;
    border-radius: 0px;
    background: var(--fe-background);
  }

  [class^="content"] {
    width: 100%;
    box-shadow: none;
    background: var(--f1f1f145-background);
    padding: 10px;
    margin-top: 10px;

    [class^="input"] {
      background: var(--white-background);
    }
  }
}

.isAutomate_iG0_I {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;

  >div {
    font-size: 18px;
    line-height: 24px;
    color: var(--black--color);
  }

  ul {
    list-style-type: disc;
    padding: 0px 0px;
    display: inline-flex;
    flex-direction: column;
    gap: 10px;
    margin: 0px;
  }

  .automateVariable_pQ1v1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    b {
      font-size: 14px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      background: var(--1e293b-color);
      color: var(--969595-fill);
      border: 1px solid var(--f5-background);
      border-radius: 6px;
      padding: 2px 8px;
      line-height: 22px;
      font-weight: 500 !important;
    }

    p,
    input {
      font-size: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin: 0;
      max-width: 100px;
      border: 1px solid var(--f5-background);
      background: var(--white-color);
      border-radius: 8px;
      padding: 2px 8px;
      line-height: 24px;
      color: var(--969595-fill);
      outline: none;
      border: none;
    }

    .buttonIcon_GIymA {
      width: 26px;
      height: 20px;
      background: transparent;
      border: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      svg {
        width: 16px;
        min-width: 16px;
        height: 16px;
      }
    }

    >div {
      display: flex;
      align-items: center;
      gap: 10px;

      button {
        background: var(--white-background);
        border: 1px solid var(--_00000036-border);
        padding: 5px;
        border-radius: 5px;
        cursor: pointer;

        &.saveButton_O_dVi {
          background: #10a37f;
          color: var(--white-color);
          border: none;
          font-size: 12px;
          padding: 7px 10px;

          &:hover {
            background: var(--_073f31-background);
            color: var(--white-color);
          }
        }
      }
    }
  }

  .automateCancelled_ZiSx1 {
    background: #ff000040;
    color: red;
    padding: 0px 10px 0px 0px;
    border-radius: 5px;
    font-size: 16px;
    line-height: 16px;
    width: 100%;
    text-align: end;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 24px 0px;
    text-transform: uppercase;

    p {
      margin: 0;
    }
  }

  .automateItem_iwGjw {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
    background: var(--white-background);

    .automateItemIcon_juCTX {
      width: 30px;
      height: 30px;
      min-width: 30px;
      border-radius: 6px;
      background-color: var(--_0000000a-background);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      margin-left: -20px;
      margin-top: 6px;
    }

    .automateItemContent_eXTvY {
      display: flex;
      flex-direction: column;
      gap: 5px;

      b {
        font-size: 14px;
        line-height: 10px;
        margin-top: 8px;
      }

      p {
        font-size: 12px;
        color: var(--_67-color);
      }
    }


    &:hover {
      background: var(--f5-background);

      .automateItemIcon_juCTX {
        background: var(--f5-background);
      }
    }

  }
}

.isAction_Hy6Ka {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;

  &.big_HO88a {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  &:not(.big_HO88a) {
    >div {
      &:nth-of-type(1) {
        margin-left: -56px;
      }

      &:nth-of-type(2) {
        margin-left: -36px;
      }

      &:nth-of-type(3) {
        margin-left: -12px;
      }
    }
  }

  >div {
    background: var(--efefef-background);
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 16px 5px 6px;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    >div {
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      background: var(--white-background);
      padding: 3px;
      font-size: 13px;
    }

    span {
      font-size: 10px;
      font-weight: 500;
    }

    p {
      font-size: 10px;
      line-height: 14px;
      font-weight: 400;
      color: #515151;
      position: absolute;
      top: -140%;
      left: 20px;
      width: 100%;
      max-width: 500px;
      background: var(--white-background);
      padding: 5px 10px 3px;
      border-radius: 10px;
      border: 1px solid var(--ed-background);
      box-shadow: 0px 1px 7px -5px var(--_00000080-background);
      transition: all 0.3s ease;
      opacity: 0;
      visibility: hidden;
    }

    &:hover {
      background: var(--white-background);

      p {
        display: block;
        opacity: 1;
        visibility: visible;
      }
    }
  }
}

.isImage__hR8U {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  max-width: 350px;
  display: flex;
  align-items: center;

  img {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.isTable_QKkCl {
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  p {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: var(--_3c3a3a-color);
    font-weight: 400;
  }
}


.messageUserContainer_vFjMA {
  display: flex;
  justify-content: end;
  flex-direction: column;
  align-items: end;
}

.messageUserContainer_vFjMA,
.botMessage_Q9b72 {
  .optionsBtnMessage_efmUB {
    padding-right: 40px;
    opacity: 0;
    transition: all 150ms;
    -webkit-transition: all 150ms;
    -moz-transition: all 150ms;
    -ms-transition: all 150ms;
    -o-transition: all 150ms;
  }

  &:hover {
    .optionsBtnMessage_efmUB {
      opacity: 1;
    }
  }
}

.userMessage_vPb7Q {
  text-align: right;
  justify-content: flex-end;
  height: fit-content;

  .fileContainerMessage_ca9sn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    background-color: var(--_0a785d6d-background);
    border-radius: 16px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    -o-border-radius: 16px;
    width: 100%;
    box-sizing: border-box;

    p {
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .iconFileContainer_uyRxh {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--_10a37f-background);
    padding: 8px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    width: fit-content;
  }

  .userMessageContainer_uOaz9 {
    font-size: 14px;
    background: var(--e6fff9-background);
    padding: 10px;
    line-height: 20px;
    border-radius: 20px;
    color: var(--_1e-color);
    display: flex;
    max-width: 400px;
    flex-direction: column;

    .date_KFi2T {
      color: var(--_5d-color);
      font-size: 10px;
      text-align: end;
    }

    .messageText_ABxYC {}
  }
}

.botMessage_Q9b72 {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;

  .message_iTnk6 {
    >div {
      font-size: 14px;
      background: var(--f9-background);
      /* padding: 20px 10px; */
      padding: 10px;
      line-height: 22px;
      border-radius: 20px;
      color: var(--_3c3a3a-color);
      /* white-space: pre-wrap; */
      /* word-wrap: break-word; */
    }
  }
}

/* .chatMenu {
  background: var(--white-background);
  height: 100%;
  width: 100%;
  min-width: 200px;

  z-index: 1;

  display: flex;
  flex-direction: column;

  .chatsContainer {
    height: calc(100% - 126px);
    overflow-y: auto;
    padding: 10px 0px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
    }

    h3 {
      font-weight: 600;
      margin: 0;
      font-size: 10px;
      color: var(--black-color);
    }

    span {
      font-weight: 600;
      margin: 0;
      font-size: 10px;
      color: var(--_8a-color);
      padding: 5px 0;
      text-align: center;
    }

    .noFilesContainer {

      h3,
      h4 {
        max-width: 95%;
        font-size: 15px;
        text-align: center;
        font-weight: 600;
        color: var(--_67-color);
      }
    }

    ul {
      padding-left: 0px;
      margin: 2px 0px;
      display: inline-flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;

      li {
        list-style: none;
        position: relative;
        padding: 8px;
        font-size: 12px;
        border-radius: 12px;
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        -ms-border-radius: 12px;
        -o-border-radius: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 5px;
        height: 20px;

        &:hover {
          background-color: var(--ececf1-background);

          .pinnedIcon {
            display: none;

          }

          .chatMenuSettings {
            display: block;
          }
        }

        input {
          background-color: transparent;
          border: none;
          outline: none;
        }

        .selectedChat {
          background: transparent;
          font-weight: 600;
          font-size: 10px;
          color: var(--_8a-color);
        }
      }

      .icon {
        opacity: 0;
      }

      .moreButton {
        display: none;
        border: none;
        background: none;
        padding: 4px;
        cursor: pointer;
        opacity: 0;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s ease-in-out;
        margin-left: auto;

        img {
          width: 18px;
          height: 18px;
        }
      }

      li:hover .moreButton {
        opacity: 0.7;
        display: flex;
      }

      .moreButton:hover {
        opacity: 1 !important;
        background: var(--ea-background);
        border-radius: 4px;
      }

      li:hover .icon {
        opacity: 1;
      }

      .agentInfo {
        display: flex;
        align-items: center;
        gap: 5px;
        min-width: 70%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .agentNameQuantityConversations {
          display: flex;
          flex-direction: column;

          span {
            padding: 0;
          }
        }
      }

      .pinnedIcon {
        display: block;


        svg {
          fill: var(--_2-color);
          color: var(--_2-color);
          height: 15px;
          width: 15px;
        }

        .pinnedIconSvg {
          fill: var(--_10a37f-background);
          color: var(--_10a37f-background);
        }
      }

      img {
        width: 32px;
        height: 32px;
        border-radius: 999px;
        -webkit-border-radius: 999px;
        -moz-border-radius: 999px;
        -ms-border-radius: 999px;
        -o-border-radius: 999px;
      }
    }

    .active {
      background-color: var(--ececf1-background);
    }
  }
}

@media (width <=768px) {
  .chatMenu {
    .chatsContainer {
      height: 65vh;
    }
  }

  .searchInputWrapper {
    display: flex;
    align-items: center;
    background: var(--white-background);
    height: 36px;
    min-height: 36px;
    border: 1px solid var(--d9d9e3-border);
    border-radius: 8px;
    padding: 0px 9px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    width: 100%;

    .searchIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: var(--_6-color);
    }

    .searchInput {
      flex: 1;
      padding: 8px;
      border: none;
      background: transparent;
      font-size: 14px;
      outline: none;
      width: 100%;

      &::placeholder {
        color: var(--_6-color);
      }
    }
  }
}

.chatMenuSettings { 
  display: none;

  button {
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
  }

  .verticalDots {
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }
} */

/* .menuOptions {
  flex-direction: column;
  gap: 10px;
  list-style: none;
  position: fixed;
  top: 0;
  left: 0;
  top: 23px;
  z-index: 999;
  padding: 4px;
  border-radius: 8px;
  background: var(--fa-background);
  box-shadow: 0 2px 10px var(--_0000001a-shadow);

  li {
    border-radius: 10px;
    background: var(--white-background);
    padding: 8px 16px;
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    color: var(--_3-color);
    border-radius: 4px;

    &:hover {
      background-color: var(--f5-background);
    }

    .chatMenuSettingsIcon {
      position: relative;

      button {
        width: 16px;
        height: 16px;
        color: var(--black-color);
        cursor: pointer;


      }

      ul {
        display: none;
        flex-direction: column;
        gap: 10px;
        list-style: none;

        li {
          padding: 10px;
          border-radius: 10px;
          background: var(--white-background);
          cursor: pointer;
          cursor: pointer;
        }
      }
    }
  }
} */

/* .searchIconsWrappers {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  user-select: none;
  border-radius: 3px;
} */

/* .searchContainerL {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 4px 0px;
  cursor: pointer;

  img {
    transition: filter 0.1s ease;
    -webkit-transition: filter 0.1s ease;
    -moz-transition: filter 0.1s ease;
    -ms-transition: filter 0.1s ease;
    -o-transition: filter 0.1s ease;
  }
} */



/* .noChats {
  flex: 1 1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--_3a-color);
  gap: 10px;
  font-weight: 600;
  justify-content: center;
  padding-top: 0;
  height: 93%;
  text-align: center;
  border: 2px dashed var(--d9d9e3-border);

  p {
    margin: 0;
    font-size: 14px;
    max-width: 95%;
    font-size: 15px;
    text-align: center;
    font-weight: 600;
    color: var(--_67-color);
  }
} */

.recommendesQuestionsContainer_Qz0Dv {
  position: absolute;
  width: 100%;
  bottom: calc(100% - 5px);
  left: 0;
  max-height: 200px;
  overflow-y: scroll;

  scrollbar-width: none;
  -ms-overflow-style: none;
}

.textBlack_FZCNa {
  color: var(--black-color);
}

.recommendesQuestionsContainer_Qz0Dv::-webkit-scrollbar {
  display: none;
}

.recomendQuestions_FijiG {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;

  overflow: hidden;

  >div {
    display: flex;
    padding: 11px 9px;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    align-self: stretch;
    border: 1px solid var(--d9d9e3-border);
    background: var(--white-background);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: var(--fa-background);
    }

    P {
      margin: 0;
      color: var(--_71-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
    }

    svg {
      height: 15px;
      width: 15px;
    }

    &:first-child {
      border-radius: 8px 8px 0 0;
      -webkit-border-radius: 8px 8px 0 0;
      -moz-border-radius: 8px 8px 0 0;
      -ms-border-radius: 8px 8px 0 0;
      -o-border-radius: 8px 8px 0 0;
    }
  }
}





.chatContainerPage_fsGcO {
  overflow-y: auto;
  height: 100vh;
  background: var(--white-background);
  border-radius: 20px 0 0 0px !important;
  /* border: 1px solid var(--ececf1-border); */
  width: 100%;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;

  &.hidden_ZpbVB {
    display: none;
  }
}

.chatAutomate_pPsuZ {
  /* height: calc(100vh - 290px); */
  height: 100%;
  overflow: clip;
}

/* .goToAgents {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  &:hover {
    .chatMenuSettings {
      display: block;
    }

    .pinnedIcon {
      display: none;
    }

    .selectedAgentContainer {
      padding-right: 12px;
    }
  }

  .selectedAgentContainer {
    position: relative;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  img {
    height: 25px;
    width: 25px;
    border-radius: 999px;
    -webkit-border-radius: 999px;
    -moz-border-radius: 999px;
    -ms-border-radius: 999px;
    -o-border-radius: 999px;
  }

  .verticalDots {
    height: 20px;
    width: 20px;
    margin-right: -12px;
  }
} */

.iconContainer_E_Aug {
  border: none;
  outline: none;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 4px;
  display: flex;
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  align-items: center;
  justify-content: center;
  height: fit-content;
  box-sizing: border-box;
  height: 25px;
  width: 25px;
  pointer-events: all;
}

.fileContainer_KmZvf {
  width: fit-content;
  background-color: var(--white-background);
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  margin: 4px 0 10px;
  border: 1px solid #cacaca;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  min-width: 200px;
  max-width: 380px;
  position: relative;
  align-items: center;

  .iconFileContainer_uyRxh {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--_10a37f-background);
    padding: 8px;
    max-width: 22px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }

  svg {
    height: 20px;
    min-width: 20px;
    fill: var(--white-background);
  }

  >div {
    overflow: hidden;

    p {
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span {
      text-transform: uppercase;
      font-size: 13px;
      color: var(--_71-color);
    }
  }

  .deleteFileButton_EZmgT {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -5px;
    right: -5px;
    background-color: var(--_3a-background);
    color: var(--white-color);
    font-size: 8px;
    height: 15px;
    min-width: 15px;
    border-radius: 999px;
    -webkit-border-radius: 999px;
    -moz-border-radius: 999px;
    -ms-border-radius: 999px;
    -o-border-radius: 999px;
    cursor: pointer;
  }
}

.agentsContainer_QpqdD {
  height: 94%;
}

/* .noFilesContainer {
  flex: 1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 2px dashed var(--d9d9e3-border);

  color: var(--_67-color);
  gap: 10px;
  font-weight: 600;
  cursor: grab;
  height: 100%; 

  h3,
  h4 {
    max-width: 85%;
    font-size: 26px;
    text-align: center;
    font-weight: 600;
    color: var(--_67-color);
  }

  svg {
    max-width: 110px;
    height: 110px;
    width: 70px;
    color: var(--_e6-color) !important;
  }
} */



.dateSeparatorContainer_vkzg7 {
  display: flex;
  flex-direction: column;
}

.lineBreak_j5B6r {
  display: none;
}

.singleLine_bS42k {
  display: none;
}

@media screen and (min-width: 1045px) {
  .lineBreak_j5B6r {
    display: block;
  }
}

@media screen and (max-width: 1044px) {
  .singleLine_bS42k {
    display: block;
  }
}

/* 
.dotsWrapperHover {}

.dotsWrapperHover:hover {
  .shadowContainer {
    opacity: 1;
  }
} */


/* .shadowContainer {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  margin-left: 6px;
  width: 15px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
} */
/* 
.dotsWrapperHoverHorizontal {}

.dotsWrapperHoverHorizontal:hover {
  .shadowContainerHorizontal {
    opacity: 1;
  }
}


.shadowContainerHorizontal {
  background-color: var(--_52525261-background);
  transition: all 300ms;
  margin-top: -2px;
  width: 27px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
} */

.highlight_YF1Ot {
  position: absolute;
  width: 90%;
  z-index: 1;
  font-size: 16px;
  top: 13px;
  left: 12px;
  pointer-events: none;
  font-family: "Inter", serif;
  color: transparent;
}


.replyContainer_Pzxuy {
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  >div {
    display: flex;
    gap: 0px;
    flex-direction: column;
    width: 100%;
    background: #cdece4;
    padding: 8px;
    border-radius: 6px;
    border-left: 4px solid #16c098;
    margin-bottom: 8px;
    text-align: left;

    b {
      font-size: 16px;
      font-weight: 600;
      color: #16c098;
    }

    p {
      font-size: 16px;
      color: var(--_71-color);
      margin: 0;
      line-height: 22px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--_71-color);

    svg {
      width: 22px;
      height: 22px;
    }
  }
}

.viewerSection_YXLs2 {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .viewerContainerSearch_fFDnV {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;

    p {
      line-height: 16px;
      font-size: 14px;
      font-weight: 600;
      color: var(--_71-color);
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 6px 10px;
      border-radius: 6px;
      background: #f4f4f4;

      svg {
        width: 14px;
        height: 14px;
      }

      input {
        border: none;
        outline: none;
        background: transparent;
        font-size: 22px;
        font-weight: 600;
        color: var(--_71-color);

        &::placeholder {
          color: var(--_71-color);
        }
      }
    }
  }

  .viewerContainer_ZGkGo {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-end;

    .viewerContainerHeader_cZFqM {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      background: #f4f4f4;
      padding: 8px 16px 8px 8px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 300ms;

      &:hover {
        background: transparent;
        transform: scale(1.02);
      }
    }

    .viewerContainerAvatar_hGkEu {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: var(--_10a37f-background);
      padding: 8px;
      border-radius: 8px;
      width: 110px;
      height: 110px;
      min-width: 110px;
      color: #fff;
      font-size: 38px;
      font-weight: 600;
    }

    .viewerContainerInfo_thcKg {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 4px;
      flex-direction: column;

      b {
        font-size: 20px;
        font-weight: 600;
        color: #000000;
      }

      span {
        font-size: 14px;
        font-weight: 600;
        color: var(--_71-color);
      }

      .viewerContainerStats_ep4ur {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-top: -4px;

        label {
          margin: 0px;
          font-size: 14px;
          font-weight: 600;
          color: var(--_71-color);
        }
      }

      .viewerContainerLabel_IxGTS {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        width: 100%;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          background: #ffffff;
          color: #454343;
          padding: 2px 6px 2px 10px;
          font-size: 12px;
        }
      }

      .viewerContainerLabelBottom_NofBJ {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        width: 100%;

        span {
          font-size: 12px;
          font-weight: 600;
          color: var(--_71-color);
        }
      }
    }

    .viewerContainerStatus_ChCiq {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      label {
        background: var(--_10a37f-background);
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        margin: 0px;
        padding: 2px 4px;
        border-radius: 12px;
      }
    }

    .viewerContainerButtons__uIzw {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      button {
        font-size: 14px;
        font-weight: 600;
        color: var(--_71-color);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 8px;
        background: #e0e0e0;
        border: none;
        border-radius: 8px;

        &.active_ANY5I {
          background: var(--_10a37f-background);
          color: #fff;
        }

        &.second_FD511 {
          background: #f4f4f4;
          border: 1px solid #e1e1e1;
        }
      }

      .viewerContainerButtonsDot_kR5Gb {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--_10a37f-background);
      }

    }

    .viewerContainerTags_VJsjU {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      .viewerContainerTagsItem_tBCyt {
        background: #fff;
        padding: 4px 5px;
        font-size: 12px;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border-radius: 6px;
        display: inline-flex;

        svg {
          cursor: pointer;
          width: 14px;
          height: 14px;
        }
      }
    }

    .viewerContainerActions_aowL7 {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      button {
        width: 35px;
        height: 35px;
        color: var(--_71-color);
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 50%;
        border: 1px solid #c6c6c6;
        background: transparent;
        cursor: pointer;

        svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}


.arrobaText_m3Sz8 {
  color: var(--_10a37f-background);
  pointer-events: auto;
  cursor: pointer;
  position: relative;
  font-size: 16px;
  top: -1px;
  z-index: 99;
  position: relative;
}

.mentionWrapper_zE5BF {
  display: inline-block;
  position: relative;

  /* background: #cdece4;
  left: 0px;
  top: -2px;
  padding: 2px 10px;
  border-radius: 10px; */
  &:before {
    display: block;
    content: "";
    position: absolute;
    left: -2px;
    top: -2px;
    border-radius: 22px;
    width: calc(100% + 6px);
    height: calc(100% + 4px);
    background: #ccebe3;
    z-index: -1;
  }
}


.mentionWrapper_zE5BF .miniProfileModal {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  display: none;
}

.mentionWrapper_zE5BF:hover .miniProfileModal {
  display: block;
}

.liSinHover_j8813 {
  all: unset;
  display: list-item;
}

.liSinHover_j8813:hover {
  background-color: inherit !important;
  color: inherit !important;
  cursor: default !important;
}

/* .groupTitle {
  font-size: 12px;
  padding: 8px;
  color: var(--black-color);
  background-color: var(--f4-background);
} */



.messageDrag_WfWbM {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  background: var(--white-background);
  border-radius: 20px 0 0 0;
  position: relative;

  &.hidden_ZpbVB {
    display: none;
  }

  .messageDragContainer_GltQd {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
    min-width: 600px;
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    height: calc(100% - 90px);
    width: 100%;

    .messageDragAgent_NtVHn {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: flex-start;
      gap: 10px;
      overflow-y: auto;
      height: 100%;
      padding: 0 2px;
      position: relative;

      .messageDragAgentItemClose_tMcQh {
        display: none;
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #494949;
        background: transparent;
        border: none;
        cursor: pointer;
        transition: all 300ms;
        padding: 0;
        margin: 0;
        outline: none;

        &:hover {
          color: var(--black-color);
        }
      }

      &.loadedAgent_a0Ovh {
        .messageDragAgentItem_GYhuJ {
          border: 2px dashed var(--_16c098-background) !important;
          background: var(--cdece445-background) !important;
        }

        .messageDragAgentItemHeader_JV0Aa {
          display: grid !important;
          grid-template-columns: 40px auto;
          align-items: flex-start !important;

          .messageDragAgentItemHeaderTags_V4fd6 {
            width: fit-content;
          }

          .messageDragAgentItemHeaderIcon_AZ2J7 {

            img {
              width: 34px !important;
              min-width: 34px !important;
              height: 34px !important;
              border: 1px solid var(--f5-background);

            }
          }

          .messageDragAgentItemHeaderContent_QOTPt {
            align-items: flex-start !important;
            gap: 5px !important;

            b {
              color: var(--_16c098-background) !important;
              font-weight: 800 !important;
            }

            p {
              color: var(--_16c098-background) !important;
              font-weight: 600 !important;
            }
          }

          .messageDragAgentItemHeaderTags_V4fd6 {
            display: none !important;
            opacity: 0;
          }
        }

        .messageDragAgentItemList_p2IsS {
          .messageDragAgentItemListNumber_GxgQw {
            border: 2px dashed var(--_16c098-background) !important;
            color: var(--_16c098-background) !important;
            background: var(--cdece445-background) !important;
            animation: backgroundChange_TijST 2s forwards !important;
          }
        }

      }

      &.loadingMessage_xWfaI {
        .messageDragAgentItem_GYhuJ {
          animation: borderPulse_uYNtx 1s infinite;
        }

        .messageDragAgentItemClose_tMcQh {
          display: inline-flex;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }




      .messageDragAgentItemAlert_Gq1q7 {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        b {
          font-size: 18px;
          font-weight: 600;
          color: var(--black-color);
          text-align: center;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          color: var(--black-color);
          text-align: center;
          margin: 0px 0px 10px;
        }

        .messageDragAgentItemAlertTags_qA2sx {
          display: inline-flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          gap: 10px;
          width: 100%;

          .messageDragAgentItemAlertTag_LkhOr {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            border: 1px solid #f2eaea;
            padding: 4px 10px;
            border-radius: 10px;
            background: var(--f5f5f569-background);
            width: 100%;
            margin: 0px;
            color: #c6c6c6;
            transition: all 300ms;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: auto;

            &:hover {
              background: var(--f5f5f538-background);
            }
          }
        }


        .messageDragAgentItemAlertButtons_V4pmM {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;

          button {
            font-size: 16px;
            font-weight: 600;
            color: var(--black-color);
            text-align: center;
            background: transparent;
            border: none;
            border-radius: 6px;
            border: 1px solid #e2e2e2;
            padding: 10px 20px;
            border-radius: 8px;
            cursor: pointer;
            transition: all 300ms;

            &:hover {
              background: var(--_16c098-background);
              color: #fff;
            }

            &.importButton_yFwcW {
              background: var(--_16c098-background);
              color: #fff;
            }
          }
        }
      }

      &.loadedAgent_a0Ovh {
        .messageDragAgentItemAlert_Gq1q7 {
          display: block;
          opacity: 1;
        }

        .messageDragAgentItemClose_tMcQh {
          display: none;
        }
      }

      .messageDragAgentItem_GYhuJ {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
        width: 93%;
        border: 2px dashed var(--ea-background);
        background: var(--_f5f5f569-background);
        border-radius: 10px;
        padding: 10px;
        cursor: pointer;
        transition: all 300ms;

        &:hover {
          background: var(--white-background);
        }

        .messageDragAgentItemHeader_JV0Aa {
          display: flex;
          align-items: center;
          gap: 6px;
          width: 100%;

          .messageDragAgentItemHeaderIcon_AZ2J7 {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 28px;

            img {
              border-radius: 50%;
              border: 1px solid var(--f5-background);
              width: 46px;
              height: 46px;
              min-width: 46px;
            }
          }

          .messageDragAgentItemHeaderContent_QOTPt {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 0px;

            b {
              font-size: 14px;
              font-weight: 600;
              color: var(--black-color);
            }

            p {
              font-size: 12px;
              color: var(--595959-color);
              margin: 0px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .messageDragAgentItemHeaderTags_V4fd6 {
            align-items: center;
            justify-content: center;
            gap: 5px;
            display: inline-flex;
            flex-direction: column;
            margin-left: auto;

            b {
              font-size: 10px;
              font-weight: 600;
              color: var(--black-color);
            }

            div {
              display: inline-flex;
              align-items: center;
              justify-content: flex-end;
              gap: 6px;

              svg {
                width: 14px;
                height: 14px;
                min-width: 14px;
              }

              .messageDragAgentItemHeaderTagsLabel_Bo_O3 {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                background: var(--e5-border);
                padding: 3px 5px;
                border-radius: 6px;
                width: fit-content;
                background: var(--16c09829-background);

                span {
                  font-size: 12px;
                  font-weight: 600;
                  color: var(--_16c098-background);
                }

                svg {
                  color: var(--_16c098-background);
                  width: 12px;
                  height: 12px;
                }
              }
            }
          }
        }

        .messageDragAgentItemList_p2IsS {
          display: none;
          padding: 0px;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 10px;
          max-width: 450px;
          width: 100%;
          margin: 0px;
          transition: all 300ms;
          opacity: 0;

          &.showList_gyCj3,
          &:hover {
            display: inline-flex !important;
            opacity: 1 !important;
            zoom: 1.2;
          }

          &.isLoading_d80DB {
            zoom: 1 !important;
          }


          li {
            width: 100%;
            position: relative;
            list-style: none;
            transition: all 0.3s ease;

            .messageDragAgentItemListContainer_eiN18 {
              opacity: 0.6;
              position: relative;
              display: flex;
              align-items: center;
              gap: 8px;
              border: 2px dashed var(--f5f5f538-background);
              padding: 5px 12px 6px 8px;
              background: #fff;
              border-radius: 12px;
            }

            .loadingBar__Y6GE {
              width: 4px;
              height: calc(100% + 10px);
              background: transparent;
              position: absolute;
              left: 20px;
              top: 0;
              z-index: 0;
              border-right: 2px dashed var(--_16c098-background);
              animation-fill-mode: forwards;
              opacity: 0;
            }

            &:last-child {
              .loadingBar__Y6GE {
                display: none;
              }
            }



            .messageDragAgentItemListNumber_GxgQw {
              width: 26px;
              height: 26px;
              min-width: 26px;
              border: 2px dashed var(--f5-background);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              font-weight: 600;
              color: #989898;
              background: var(--f4-background);

            }


            .messageDragAgentItemListContent_RBmeY {
              display: flex;
              justify-content: center;
              gap: 3px;
              height: 100%;
              flex-direction: column;
              margin: 2px 0px;

              p {
                font-size: 16px;
                font-weight: 600;
                color: var(--black-color);
                margin: 0px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              span {
                font-size: 12px;
                color: var(--_3a-color);
                margin: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .messageDragAgentItemListTags_rbKKn {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 10px;
              font-weight: 500;
              margin-left: auto;
              margin-right: 5px;
              background: #16c098;
              color: #fff;
              padding: 5px;
              border-radius: 12px;


            }

            &.pending_UfAcD {
              .messageDragAgentItemListContainer_eiN18 {
                opacity: 1;
                border: 2px dashed var(--_16c098-background);
                animation: borderPulse_uYNtx 1s infinite;
              }

              .messageDragAgentItemListNumber_GxgQw {
                border: none;
                animation: backgroundPulse1_megnf 2s infinite;
              }
            }

            &.active_ANY5I {

              .loadingBar__Y6GE {
                animation: loadingBar__Y6GE 1.2s ease forwards;
              }

              .messageDragAgentItemListContainer_eiN18 {
                opacity: 1;
                border: 2px dashed var(--_16c098-background);
                background: #f1faf8 !important;

                p,
                span {
                  color: var(--_16c098-background) !important;
                }
              }

              .messageDragAgentItemListNumber_GxgQw {
                border: 2px dashed var(--_16c098-background);
                color: var(--_16c098-background);
                background: var(--cdece445-background);
                animation: backgroundChange_TijST 2s forwards;
              }



            }
          }
        }

        &:hover {
          .messageDragAgentItemList_p2IsS {
            display: inline-flex;
          }
        }
      }
    }
  }


  .messageDragAgent_NtVHn.big_HO88a {
    .messageDragAgentItem_GYhuJ {
      height: 100% !important;
    }

    .messageDragAgentItemHeader_JV0Aa {
      flex-direction: column !important;
    }

    .messageDragAgentItemHeaderContent_QOTPt {
      align-items: center !important;
      gap: 10px !important;
    }

    .messageDragAgentItemHeaderTags_V4fd6 {
      margin-left: unset !important;
      flex-direction: unset !important;
    }

    .messageDragAgentItemHeaderIcon_AZ2J7 {
      svg {
        width: 30px !important;
        height: 30px !important;
      }
    }
  }


  .messageDragAttachment_szNi7 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    height: -webkit-fill-available;
    border-radius: 10px;
    border: 2px dashed var(--_16c098-background);
    padding: 10px;
    background: var(--cdece445-background);
    cursor: pointer;

    svg {
      width: 60px;
      height: 60px;
      color: var(--16C097-fill);
    }

    p {
      margin: 0;
      font-size: 20px;
      color: var(--_16c098-background);
    }
  }
}





@keyframes backgroundChange_TijST {
  0% {
    background: var(--cdece445-background);
    color: #fff;
  }

  100% {
    background: var(--_16c098-background);
    color: #fff;
  }
}

@keyframes backgroundPulse1_megnf {
  0% {
    background: var(--_16c0982e-background);
    color: var(--_16c098-background);
    transform: scale(1);
    opacity: 1;
  }

  50% {
    background: #f1faf8 !important;
    color: var(--_16c098-background);
    opacity: 0.7;
    transform: scale(1.10);
  }

  100% {
    background: var(--_16c0982e-background);
    color: var(--_16c098-background);
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes loadingBar__Y6GE {
  0% {
    transform: scaleY(0);
    transform-origin: top;
    opacity: 1;
  }

  100% {
    transform: scaleY(1);
    transform-origin: top;
    opacity: 1;
  }
}

@keyframes borderPulse_uYNtx {
  0% {
    border-color: var(--f5-background);
  }

  50% {
    border-color: var(--e0-border);
  }

  100% {
    border-color: var(--f5-background);
  }
}
















.messageAutomateItem_PM_Jn {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  width: 93%;
  cursor: pointer;
  transition: all 300ms;
  max-width: 460px;

  .messageAutomateItemHeader_GSmtj {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    .messageAutomateItemHeaderIcon_ZNsul {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 36px;
      height: 36px;
      min-width: 36px;
      border-radius: 50%;

      img {
        width: 40px;
        height: 40px;
        border: 1px solid var(--f5-background);
        border-radius: 50%;
      }
    }

    .messageAutomateItemHeaderContent_AUK8E {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      gap: 2px;

      b {
        font-size: 20px;
        font-weight: 600;
        color: var(--black-color);
      }

      p {
        font-size: 12px;
        color: var(--595959-color);
        margin: 0px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .messageAutomateItemHeaderTags_LH7as {
      align-items: center;
      justify-content: center;
      gap: 5px;
      display: inline-flex;
      flex-direction: column;
      margin-left: auto;

      b {
        font-size: 10px;
        font-weight: 600;
        color: var(--black-color);
      }

      div {
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        gap: 6px;

        svg {
          width: 14px;
          height: 14px;
        }

        .messageAutomateItemHeaderTagsLabel_vrRUV {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          background: var(--e5-border);
          padding: 3px 5px;
          border-radius: 6px;
          width: fit-content;
          background: var(--16c09829-background);

          span {
            font-size: 12px;
            font-weight: 600;
            color: var(--_16c098-background);
          }

          svg {
            color: var(--_16c098-background);
            width: 12px;
            height: 12px;
          }
        }
      }
    }
  }

  .messageAutomateItemList_EWN5K {
    padding: 0px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    height: 100%;
    width: 100%;
    margin: 0px;
    transition: all 300ms;

    li {
      width: 100%;
      position: relative;
      list-style: none;
      transition: all 0.3s ease;

      .messageAutomateItemListContainer_nO5_i {
        position: relative;
        display: flex;
        align-items: center;
        gap: 12px;
        border: 2px dashed var(--f5-background);
        padding: 5px 12px 6px 8px;
        background: #fff;
        border-radius: 12px;
      }

      .loadingBar__Y6GE {
        width: 4px;
        height: calc(100% + 10px);
        background: transparent;
        position: absolute;
        left: 22px;
        top: 0;
        z-index: 0;
        border-right: 2px solid var(--_16c098-background);
        animation: loadingBar__Y6GE 1.8s ease forwards;
        animation-delay: calc(var(--index) * .8s);
        opacity: 0;
        animation-fill-mode: forwards;

      }

      &:last-child {
        .loadingBar__Y6GE {
          display: none;
        }
      }



      .messageAutomateItemListNumber_IapU7 {
        width: 26px;
        height: 26px;
        min-width: 26px;
        border: 2px dashed var(--_16c098-background);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        color: var(--_16c098-background);
        background: var(--cdece445-background);
      }

      .messageAutomateItemListContent_s91ND {
        display: flex;
        justify-content: center;
        gap: 4px;
        height: 100%;
        flex-direction: column;
        margin: 2px 0px;

        p {
          font-size: 16px;
          font-weight: 600;
          color: var(--black-color);
          margin: 0px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        span {
          font-size: 12px;
          color: var(--595959-color);
          margin: 0px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .messageAutomateItemListTags_Iep29 {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        margin-left: auto;
        margin-right: 0px;
        font-weight: 500;
        background: var(--16c09829-background);
        color: var(--_10a37f-background);
        padding: 5px;
        border-radius: 11px;

        div {
          width: 40px;
          min-width: 40px;
          max-width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: var(--f5-background);
          margin-right: -20px;
          box-shadow: 0 0 8px -5px var(--black-color);
        }
      }




    }
  }

}


/* 
.communitiContainer {
  flex: 1;
  position: relative;
  width: 100%;
  background: var(--f1-background);
}

.communiti {
  all: unset;
  display: flex;
  align-items: center;
  background-color: var(--_16c0982e-background);
  color: var(--16C097-fill);
  position: relative;
  bottom: 0;
  margin: 0px 0px 58px 0px;
  border-radius: 9px;
  padding: 8px 8px 8px 8px;
  flex: 1 1;
  font-size: 12px;
  font-weight: bold;
  gap: 8px;
  width: 92%;
  cursor: pointer;

  svg {
    width: 20px;
  }

  &:hover {
    background-color: var(--f5-background);
  }
}
 */


.highlightedTextContainer_hB2Lb {
  position: relative;
  width: 100%;
}

.highlightedCitation_fn9op {
  background-color: rgba(22, 192, 152, 0.1);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.highlightedCitation_fn9op:hover {
  background-color: rgba(22, 192, 152, 0.2);
}

.citationPopup_wPIYC {
  gap: 20px;
  transform: translateX(-50%);
  background: #000000;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  max-width: 300px;
  display: inline-flex;
}

.citationPopup_wPIYC b {
  margin: 0px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  min-width: 60%;
}

.citationPopup_wPIYC a {
  color: var(--_16c098-background);
  text-decoration: none;
  font-size: 12px;
  line-height: 14px;
  word-break: break-all;
  text-align: right;
}

.citationPopup_wPIYC a:hover {
  text-decoration: underline;
}

.dotsContainer_RajZe {
  display: flex;
  gap: 2px;
  font-size: 30px;
  font-weight: bold;
  background: linear-gradient(90deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  background-clip: text;
  margin-bottom: -2px;
  margin-top: -14px;
}

.dot_n_P6L {
  animation: jump_HI9Ht 1.2s infinite ease-in-out;
}

.dot_n_P6L:nth-child(2) {
  animation-delay: 0.2s;
}

.dot_n_P6L:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes jump_HI9Ht {

  0%,
  100% {
    transform: translateY(0);
    opacity: 0.3;
  }

  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
}

.profileImage_WPUT8 {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 100px;
}



.chatRecorder_XR6j6 {
  background: #f4f4f4;
  border-radius: 12px;
  padding: 4px 16px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* width: 100%; */
  max-width: 600px;
  margin: 0 auto 10px;

  .chatRecorderPlay_WKxL5 {
    justify-content: flex-end;
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    height: 0px;

    button {

      background: #f7f7f7;
      color: white;
      border-radius: 50%;
      padding: 4px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      width: 40px;
      height: 40px;
      font-size: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      top: -35px;
      right: -40px;
      position: relative;

      &:hover {
        background: #e2e2e2;
      }
    }
  }

  .chatRecorderPlayButton_ksVq7 {
    background: #4caf50;
    color: white;
    border-radius: 6px;
    padding: 4px 12px;
  }

  .chatRecorderBars_reCJJ {
    display: flex;
    align-items: flex-end;
    height: 40px;
    width: 100%;
    gap: 2px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    margin-bottom: -8px;
    position: relative;
  }

  .chatRecorderBarsBar_yb4oC {
    margin-top: 8px;
    font-size: 13px;
    color: #555;
    margin-left: auto;
    height: 0px;

    span {
      position: relative;
      height: 0px;
      top: -18px;
      font-size: 10px;
      font-weight: 600;
    }
  }
}

.stickyDateSeparator_XWGG2,
.staticDateLabel_zR6EM {
  position: sticky;
  top: 0;
  background: white;
  padding: 6px 12px;
  margin: 0 auto;
  z-index: 2;
  /* border-bottom: 1px solid #eee; */
  width: fit-content;

}

.stickyDateSeparator_XWGG2 {
  position: fixed;
  top: 55px;
  left: calc(50% + 138px);
  /* desplazamiento horizontal */
  transform: translateX(-50%);
  /* centrado basado en ancho real */
  /* width: 150px; */
  /* background-color: red; */
}

.staticDateLabel_zR6EM {
  position: initial;
  z-index: 2;
}

.invisibleDateSeparator_QGKVQ {
  height: 1px;
  opacity: 0;
}


.voiceRecorderContainer_XzFZ3 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}




.voiceMessageBubble_WaXwT {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
  background: #fff;
  border-radius: 12px;
  padding: 4px 16px;
  max-width: 600px;
  min-width: 100px;
  margin: 0px;
  position: relative;

  .voiceMessageBubbleTime_GXfME {
    position: absolute;
    left: -15px;
    bottom: -20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    button {
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
      border: 0;
      padding: 0px;
    }

    span {
      font-size: 10px;
      color: #575757;
      min-width: 80px;
      text-align: left;
    }
  }
}

/* Estilos para el formateo de texto similar a WhatsApp */
.botMessage_Q9b72 .message_iTnk6 div {

  /* Estilos para títulos */
  h1 {
    font-size: 1.5em;
    font-weight: bold;
    margin: 0.5em 0;
    color: var(--_2-color);
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
    /* margin: 0.4em 0; */
    color: var(--_2-color);
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 0.3em 0;
    color: var(--_2-color);
  }

  /* Estilos para negrita */
  b {
    font-weight: bold;
  }

  /* Estilos para cursiva */
  i {
    font-style: italic;
  }

  /* Estilos para subrayado */
  u {
    text-decoration: underline;
  }

  /* Estilos para tachado */
  s {
    text-decoration: line-through;
  }

  /* Estilos para código inline */
  code {
    background-color: #f1f1f1;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
    font-size: 0.9em;
  }

  /* Estilos para bloques de código */
  pre {
    border-radius: 5px;
    padding: 0px;
    margin: 0px;
    overflow-x: auto;
    min-height: 95%;

    code {
      background: none;
      padding: 0;
      border-radius: 0;
    }
  }

  /* Saltos de línea */
  br {
    display: block;
    margin: 2px 0;
  }
}

.isDoc_orTIj {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0px !important;
  background: transparent !important;

  .isDocContainer_qGjtN {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    background: var(--f5-background);
    border-radius: 10px;
    border: 1px solid var(--e9e9e9-background);
    /* margin: 10px 0; */
    flex-direction: column;

    .docMessage__lz98 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      width: 100%;
      gap: 10px;
      padding: 0px;

      .docMessageHeader_bXGYg {
        background: var(--f5-background);
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 10px;
        position: sticky;
        top: 0px;
        z-index: 1;

        p {
          margin: 0;
          font-weight: 500;
          color: var(--2-color);
        }

        .viewDocButton_A_QZg {
          background: #10a37f;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: background-color 0.2s ease;

          &:hover {
            background: #068a69;
          }
        }
      }

    }

    .docMessageContent_X8Ng3 {
      width: 100%;
      height: 100%;
      /* background: #fff; */
      border-radius: 10px;
      max-height: 130px;
      overflow: hidden;

      &.docMessageContentShowMore_ombBN {
        max-height: unset;
      }

      /* padding: 10px; */
    }

    .docMessageShowMore_yQcYo {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      width: 100%;
      transition: all 0.3s ease;


      >div {
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        background: var(--f5-background);
        padding: 2px 10px;
        border-radius: 10px;
        border: 1px solid var(--e9e9e9-background);
        z-index: 9;
        color: #10a37f;

        svg {
          width: 10px;
          height: 10px;
        }
      }

      &.docMessageShowMoreShowMore_McA9d {
        margin-top: -20px;

        >div {
          padding: 5px 10px;
        }

        svg {
          transform: rotate(180deg);
        }
      }


      &:after {
        content: '';
        position: absolute;
        width: 95%;
        height: 2px;
        background: #10a37f;
        border-radius: 4px;
        z-index: 1;
      }

      &:hover {
        >div {
          color: #06785c;
        }

        svg {
          color: #06785c;
        }

        &:after {
          background: #06785c;
        }
      }
    }
  }

  .isDocLogs_aVoU3 {
    ul {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 0px 2px;
      margin: 0px;

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;

        b {
          font-size: 12px;
          font-weight: 500;
          color: var(--2-color);
        }

        p {
          font-size: 14px;
          font-weight: 600;
          color: var(--00a3a3-color);
        }
      }
    }
  }
}















.document-container {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
}

.page {
  background: white;
  /* margin: 0px 0px 20px; */
  padding: 15px;
  margin: 0px;
  border-radius: 8px;
  /* border: 1px solid #ddd; */
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
  min-height: 800px;
  height: 800px;
  position: relative;
}

.page-content {
  height: 100%;
  /* margin-bottom: 60px; */
  white-space: unset;
  word-wrap: unset;

  >section {
    height: 100%;
  }
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #333;
  padding-bottom: 20px;
}

.document-title {
  color: #2c3e50;
  margin: 0 0 10px 0;
  font-size: 2.5em;
}

.document-subtitle {
  color: #7f8c8d;
  margin: 0;
  font-size: 1.2em;
  font-weight: normal;
}

.header-divider {
  border: none;
  height: 2px;
  background: linear-gradient(to right, #3498db, #2ecc71);
  margin: 20px 0;
}

.page-footer {
  position: absolute !important;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.footer-divider {
  border: none;
  height: 1px;
  background: #bdc3c7;
  margin-bottom: 15px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  font-size: 0.9em;
  color: #7f8c8d;
}


.page-break {
  page-break-after: always;
  height: 0;
  margin: 0;
  border: 0;
}


.page_LRvzK {

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #2c3e50;
    margin-top: 25px;
    margin-bottom: 15px;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
  }

  th {
    background-color: #f8f9fa;
    font-weight: bold;
  }

  ul,
  ol {
    margin: 15px 0;
    padding-left: 30px;
  }

  li {
    margin-bottom: 8px;
  }

  blockquote {
    border-left: 4px solid #3498db;
    margin: 20px 0;
    padding: 15px 20px;
    background: #f8f9fa;
    font-style: italic;
  }

  code {
    background: #f1f2f6;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
  }

  pre {
    background: #2c3e50;
    color: #ecf0f1;
    padding: 15px;
    border-radius: 5px;
    overflow-x: auto;
  }
}

/* Section Indicator Styles */
.sectionIndicator_dLHci {
  background: var(--white-background);
  color: var(--black-color);
  padding: 4px 6px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: all 0.3s ease;

  .sectionInfo_BeuEj {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    .sectionId_fS3Lr {
      font-size: 14px;
      opacity: 0.9;
      /* font-family: 'Courier New', monospace; */
      flex: 1 1;
    }

    .sectionActions_zLkGV {
      display: flex;
      gap: 4px;

      .sectionActionBtn_C8VVq {
        background: var(--f5-background);
        border: none;
        color: var(--6b7280-color);
        width: 24px;
        height: 24px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: scale(1.05);
        }

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }

  .sectionLogs_KeNM0 {
    ul {
      list-style: none;
      padding: 0px;
      margin: 0px;

      li {
        display: flex;
        align-items: center;
        gap: 10px;

        svg {
          width: 16px;
          height: 16px;
        }

        p {
          font-size: 12px;
          font-weight: 500;
          color: var(--2-color);
        }

        b {
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}

.folderIndicatorContainer_CATE_ {
  margin-bottom: 12px;
  position: relative;
  /* z-index: 100; */
  background: white;
  border-radius: 8px;
  animation: slideInFromTop_DPrIH 0.3s ease-out;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  /* border: 1px solid #e5e7eb; */
}

@keyframes slideInFromTop_DPrIH {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== ESTILOS PARA SCRAPING ===== */
.scrapingButtonContainer_OK_WS {
    margin-top: 30px;
    text-align: center;
}

.scrapingButton_tmrtb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 15px 30px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.scrapingButton_tmrtb:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.scrapingButton_tmrtb:active {
    transform: translateY(0);
}

.scrapingMessage_j0SKW {
    margin: 20px 0;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 12px;
    border: 1px solid #e9ecef;
}

.scrapingMessage_j0SKW .scrapingContainer_epryS {
    max-width: none;
    margin: 0;
    padding: 0;
    background: transparent;
    box-shadow: none;
}

/* Responsive para scraping */
@media (max-width: 768px) {
    .scrapingButton_tmrtb {
        padding: 12px 24px;
        font-size: 14px;
    }
    
    .scrapingMessage_j0SKW {
        margin: 15px 0;
        padding: 15px;
    }
}

.appIndicatorContainer_ZxHwg {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ChatView.module.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,+CAA+C;EAC/C,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;;;GAGG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;;EAEX;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,cAAc;;EAEd;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;;EAEf;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,gDAAgD;EAChD,yBAAyB;;EAEzB;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;;IAEb;MACE,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,aAAa;MACb,uBAAuB;MACvB,sBAAsB;;MAEtB;QACE,SAAS;QACT,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,iCAAiC;QACjC,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;MAClB;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,gBAAgB;;MAEhB;QACE,YAAY;QACZ,iCAAiC;MACnC;IACF;EACF;;EAEA;IACE,YAAY;EACd;;AAEF;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX;;;;uBAIqB;EACrB,0BAA0B;EAC1B,gDAA0C;EAC1C,YAAY;EACZ,wDAAkD;;EAElD;IACE,cAAc;EAChB;AACF;;;;AAIA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;;AAGF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;;EAEX;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,yCAAyC;IACzC,iBAAiB;IACjB,mBAAmB;IACnB,mDAAmD;;IAEnD;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;;MAEf;QACE,WAAW;QACX,YAAY;MACd;IACF;EACF;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,oCAAoC;EACpC,uCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;;EAEtB,6BAA6B;;;;EAI7B;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;;;IAGlB;MACE,qBAAqB;MACrB,sBAAsB;IACxB;;IAEA;MACE,+BAA+B;MAC/B,gCAAgC;;IAElC;;IAEA;MACE,aAAa;MACb,SAAS;MACT,mBAAmB;IACrB;;IAEA;MACE,QAAQ;MACR,mBAAmB;MACnB,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,kBAAkB;MAClB,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,aAAa;MACb,kBAAkB;MAClB,yCAAyC;MACzC,0BAA0B;MAC1B,uBAAuB;MACvB,eAAe;MACf,YAAY;MACZ,gBAAgB;MAChB,sCAAsC;;MAEtC;QACE,qBAAqB;QACrB,sBAAsB;MACxB;;MAEA;QACE,2CAA2C;;QAE3C;UACE,+BAA+B;UAC/B,gCAAgC;QAClC;MACF;;;MAGA;QACE,2BAA2B;QAC3B,kBAAkB;QAClB,qBAAqB;QACrB,iBAAiB;QACjB,uCAAuC;QACvC,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,UAAU;QACV,kBAAkB;QAClB,yBAAyB;;MAE3B;;MAEA;QACE,WAAW;QACX,kBAAkB;QAClB,qBAAqB;QACrB,SAAS;QACT,2BAA2B;QAC3B,6BAA6B;QAC7B,gDAAgD;QAChD,UAAU;QACV,kBAAkB;QAClB,yBAAyB;MAC3B;;MAEA;;QAEE,UAAU;QACV,mBAAmB;MACrB;;MAEA;;QAEE,WAAW;QACX,YAAY;MACd;IACF;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;;EAEjC;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,QAAQ;;EAEV;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;;EAElB;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;;EAEhB;IACE,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;IACzC,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE;IACE;MACE,SAAO;MACP,eAAe;MACf,gBAAgB;;MAEhB;QACE,YAAY;QACZ,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,UAAU;;EAEV;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;EACzC;AACF;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;;EAET;IACE,eAAe;IACf,0CAA0C;IAC1C,6DAA6D;IAC7D,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB;MACE,6DAA6D;MAC7D,gCAAgC;MAChC,oBAAoB;MACpB,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,gBAAgB;;IAEhB;MACE,mCAAmC;IACrC;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;;EAEb;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;MACE,eAAe;MACf,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,+BAA+B;MAC/B,yBAAyB;MACzB,sCAAsC;MACtC,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,2BAA2B;IAC7B;;IAEA;;MAEE,eAAe;MACf,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;MACnB,SAAS;MACT,gBAAgB;MAChB,sCAAsC;MACtC,8BAA8B;MAC9B,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,aAAa;MACb,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,uBAAuB;MACvB,YAAY;MACZ,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;;MAEf;QACE,WAAW;QACX,eAAe;QACf,YAAY;MACd;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;QACE,mCAAmC;QACnC,yCAAyC;QACzC,YAAY;QACZ,kBAAkB;QAClB,eAAe;;QAEf;UACE,mBAAmB;UACnB,yBAAyB;UACzB,YAAY;UACZ,eAAe;UACf,iBAAiB;;UAEjB;YACE,qCAAqC;YACrC,yBAAyB;UAC3B;QACF;MACF;IACF;EACF;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;;IAEzB;MACE,SAAS;IACX;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,mCAAmC;;IAEnC;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,6CAA6C;MAC7C,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;;MAER;QACE,eAAe;QACf,iBAAiB;QACjB,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,uBAAuB;MACzB;IACF;;;IAGA;MACE,gCAAgC;;MAEhC;QACE,gCAAgC;MAClC;IACF;;EAEF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;;EAEb;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE;MACE;QACE,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;MACpB;IACF;EACF;;EAEA;IACE,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;;IAEzB;MACE,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,mCAAmC;MACnC,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,kBAAkB;MAClB,UAAU;MACV,UAAU;MACV,WAAW;MACX,gBAAgB;MAChB,mCAAmC;MACnC,qBAAqB;MACrB,mBAAmB;MACnB,sCAAsC;MACtC,wDAAwD;MACxD,yBAAyB;MACzB,UAAU;MACV,kBAAkB;IACpB;;IAEA;MACE,mCAAmC;;MAEnC;QACE,cAAc;QACd,UAAU;QACV,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;;;AAGA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE;IACE,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,6CAA6C;IAC7C,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;;IAEtB;MACE,SAAS;MACT,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;IACzB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oCAAoC;IACpC,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;;IAEtB;MACE,uBAAuB;MACvB,eAAe;MACf,eAAe;IACjB;;IAEA,oBAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;;EAElB;IACE;MACE,eAAe;MACf,gCAAgC;MAChC,wBAAwB;MACxB,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,2BAA2B;MAC3B,2BAA2B;MAC3B,2BAA2B;IAC7B;EACF;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmQG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwDG;;AAEH;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;;;;;GAcG;;;;AAIH;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;;EAElB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB,gBAAgB;;EAEhB;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;IACnC,eAAe;IACf,yBAAyB;;IAEzB;MACE,gCAAgC;IAClC;;IAEA;MACE,SAAS;MACT,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,YAAY;MACZ,WAAW;IACb;;IAEA;MACE,0BAA0B;MAC1B,kCAAkC;MAClC,+BAA+B;MAC/B,8BAA8B;MAC9B,6BAA6B;IAC/B;EACF;AACF;;;;;;AAMA;EACE,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,4CAA4C;EAC5C,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,aAAa;EACf;AACF;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG;;AAEH;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;;EAEnB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;;IAEhB;MACE,SAAS;MACT,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;MACzB,eAAe;MACf,uBAAuB;IACzB;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,uCAAuC;IACvC,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;;;;AAIH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;;GAOG;;;AAGH;;;;;;;;;;;;;;;GAeG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;EACf,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;;EAET;IACE,aAAa;IACb,QAAQ;IACR,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;;IAEhB;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,uBAAuB;MACvB,SAAS;MACT,iBAAiB;MACjB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;MAC5B,gBAAgB;MAChB,uBAAuB;IACzB;EACF;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,uBAAuB;;IAEvB;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;;IAEtB;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;;MAEnB;QACE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,uBAAuB;;QAEvB;UACE,uBAAuB;QACzB;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;;IAErB;MACE,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAC3B,SAAS;MACT,mBAAmB;MACnB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;MACf,qBAAqB;;MAErB;QACE,uBAAuB;QACvB,sBAAsB;MACxB;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,qCAAqC;MACrC,YAAY;MACZ,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,uBAAuB;MACvB,QAAQ;MACR,sBAAsB;;MAEtB;QACE,eAAe;QACf,gBAAgB;QAChB,cAAc;MAChB;;MAEA;QACE,eAAe;QACf,gBAAgB;QAChB,uBAAuB;MACzB;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,gBAAgB;;QAEhB;UACE,WAAW;UACX,eAAe;UACf,gBAAgB;UAChB,uBAAuB;QACzB;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,SAAS;QACT,WAAW;;QAEX;UACE,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,QAAQ;UACR,mBAAmB;UACnB,cAAc;UACd,yBAAyB;UACzB,eAAe;QACjB;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,SAAS;QACT,WAAW;;QAEX;UACE,eAAe;UACf,gBAAgB;UAChB,uBAAuB;QACzB;MACF;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,qCAAqC;QACrC,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,mBAAmB;MACrB;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;;QAElB;UACE,qCAAqC;UACrC,WAAW;QACb;;QAEA;UACE,mBAAmB;UACnB,yBAAyB;QAC3B;MACF;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,qCAAqC;MACvC;;IAEF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,kBAAkB;QAClB,oBAAoB;;QAEpB;UACE,eAAe;UACf,WAAW;UACX,YAAY;QACd;MACF;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;;MAET;QACE,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,uBAAuB;QACvB,eAAe;;QAEf;UACE,WAAW;UACX,YAAY;QACd;MACF;IACF;EACF;AACF;;;AAGA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB;;;;wBAIsB;EACtB;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;EACb;AACF;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;;;GAKG;;;;AAIH;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;;EAElB;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,WAAW;;IAEX;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,sBAAsB;MACtB,2BAA2B;MAC3B,SAAS;MACT,gBAAgB;MAChB,YAAY;MACZ,cAAc;MACd,kBAAkB;;MAElB;QACE,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,qBAAqB;QACrB,UAAU;QACV,SAAS;QACT,aAAa;;QAEb;UACE,yBAAyB;QAC3B;MACF;;MAEA;QACE;UACE,uDAAuD;UACvD,iDAAiD;QACnD;;QAEA;UACE,wBAAwB;UACxB,gCAAgC;UAChC,kCAAkC;;UAElC;YACE,kBAAkB;UACpB;;UAEA;;YAEE;cACE,sBAAsB;cACtB,0BAA0B;cAC1B,uBAAuB;cACvB,sCAAsC;;YAExC;UACF;;UAEA;YACE,kCAAkC;YAClC,mBAAmB;;YAEnB;cACE,2CAA2C;cAC3C,2BAA2B;YAC7B;;YAEA;cACE,2CAA2C;cAC3C,2BAA2B;YAC7B;UACF;;UAEA;YACE,wBAAwB;YACxB,UAAU;UACZ;QACF;;QAEA;UACE;YACE,uDAAuD;YACvD,2CAA2C;YAC3C,iDAAiD;YACjD,wDAAkD;UACpD;QACF;;MAEF;;MAEA;QACE;UACE,wCAAkC;QACpC;;QAEA;UACE,oBAAoB;QACtB;MACF;;MAEA;QACE,aAAa;MACf;;;;;MAKA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;QACT,WAAW;;QAEX;UACE,eAAe;UACf,gBAAgB;UAChB,yBAAyB;UACzB,kBAAkB;QACpB;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,yBAAyB;UACzB,kBAAkB;UAClB,oBAAoB;QACtB;;QAEA;UACE,oBAAoB;UACpB,eAAe;UACf,mBAAmB;UACnB,uBAAuB;UACvB,SAAS;UACT,WAAW;;UAEX;YACE,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,SAAS;YACT,yBAAyB;YACzB,iBAAiB;YACjB,mBAAmB;YACnB,sCAAsC;YACtC,WAAW;YACX,WAAW;YACX,cAAc;YACd,qBAAqB;YACrB,mBAAmB;YACnB,gBAAgB;YAChB,uBAAuB;YACvB,WAAW;;YAEX;cACE,sCAAsC;YACxC;UACF;QACF;;;QAGA;UACE,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,SAAS;;UAET;YACE,eAAe;YACf,gBAAgB;YAChB,yBAAyB;YACzB,kBAAkB;YAClB,uBAAuB;YACvB,YAAY;YACZ,kBAAkB;YAClB,yBAAyB;YACzB,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,qBAAqB;;YAErB;cACE,qCAAqC;cACrC,WAAW;YACb;;YAEA;cACE,qCAAqC;cACrC,WAAW;YACb;UACF;QACF;MACF;;MAEA;QACE;UACE,cAAc;UACd,UAAU;QACZ;;QAEA;UACE,aAAa;QACf;MACF;;MAEA;QACE,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,UAAU;QACV,uCAAuC;QACvC,uCAAuC;QACvC,mBAAmB;QACnB,aAAa;QACb,eAAe;QACf,qBAAqB;;QAErB;UACE,mCAAmC;QACrC;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,QAAQ;UACR,WAAW;;UAEX;YACE,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,SAAS;;YAET;cACE,kBAAkB;cAClB,sCAAsC;cACtC,WAAW;cACX,YAAY;cACZ,eAAe;YACjB;UACF;;UAEA;YACE,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,uBAAuB;YACvB,QAAQ;;YAER;cACE,eAAe;cACf,gBAAgB;cAChB,yBAAyB;YAC3B;;YAEA;cACE,eAAe;cACf,0BAA0B;cAC1B,WAAW;cACX,mBAAmB;cACnB,gBAAgB;cAChB,uBAAuB;YACzB;UACF;;UAEA;YACE,mBAAmB;YACnB,uBAAuB;YACvB,QAAQ;YACR,oBAAoB;YACpB,sBAAsB;YACtB,iBAAiB;;YAEjB;cACE,eAAe;cACf,gBAAgB;cAChB,yBAAyB;YAC3B;;YAEA;cACE,oBAAoB;cACpB,mBAAmB;cACnB,yBAAyB;cACzB,QAAQ;;cAER;gBACE,WAAW;gBACX,YAAY;gBACZ,eAAe;cACjB;;cAEA;gBACE,oBAAoB;gBACpB,mBAAmB;gBACnB,uBAAuB;gBACvB,QAAQ;gBACR,4BAA4B;gBAC5B,gBAAgB;gBAChB,kBAAkB;gBAClB,kBAAkB;gBAClB,sCAAsC;;gBAEtC;kBACE,eAAe;kBACf,gBAAgB;kBAChB,gCAAgC;gBAClC;;gBAEA;kBACE,gCAAgC;kBAChC,WAAW;kBACX,YAAY;gBACd;cACF;YACF;UACF;QACF;;QAEA;UACE,aAAa;UACb,YAAY;UACZ,sBAAsB;UACtB,uBAAuB;UACvB,2BAA2B;UAC3B,SAAS;UACT,gBAAgB;UAChB,WAAW;UACX,WAAW;UACX,qBAAqB;UACrB,UAAU;;UAEV;;YAEE,+BAA+B;YAC/B,qBAAqB;YACrB,SAAS;UACX;;UAEA;YACE,kBAAkB;UACpB;;;UAGA;YACE,WAAW;YACX,kBAAkB;YAClB,gBAAgB;YAChB,yBAAyB;;YAEzB;cACE,YAAY;cACZ,kBAAkB;cAClB,aAAa;cACb,mBAAmB;cACnB,QAAQ;cACR,6CAA6C;cAC7C,yBAAyB;cACzB,gBAAgB;cAChB,mBAAmB;YACrB;;YAEA;cACE,UAAU;cACV,yBAAyB;cACzB,uBAAuB;cACvB,kBAAkB;cAClB,UAAU;cACV,MAAM;cACN,UAAU;cACV,kDAAkD;cAClD,6BAA6B;cAC7B,UAAU;YACZ;;YAEA;cACE;gBACE,aAAa;cACf;YACF;;;;YAIA;cACE,WAAW;cACX,YAAY;cACZ,eAAe;cACf,uCAAuC;cACvC,kBAAkB;cAClB,aAAa;cACb,mBAAmB;cACnB,uBAAuB;cACvB,eAAe;cACf,gBAAgB;cAChB,cAAc;cACd,gCAAgC;;YAElC;;;YAGA;cACE,aAAa;cACb,uBAAuB;cACvB,QAAQ;cACR,YAAY;cACZ,sBAAsB;cACtB,eAAe;;cAEf;gBACE,eAAe;gBACf,gBAAgB;gBAChB,yBAAyB;gBACzB,WAAW;gBACX,mBAAmB;gBACnB,gBAAgB;gBAChB,uBAAuB;cACzB;;cAEA;gBACE,eAAe;gBACf,uBAAuB;gBACvB,SAAS;gBACT,mBAAmB;gBACnB,gBAAgB;gBAChB,uBAAuB;cACzB;YACF;;YAEA;cACE,aAAa;cACb,mBAAmB;cACnB,uBAAuB;cACvB,eAAe;cACf,gBAAgB;cAChB,iBAAiB;cACjB,iBAAiB;cACjB,mBAAmB;cACnB,WAAW;cACX,YAAY;cACZ,mBAAmB;;;YAGrB;;YAEA;cACE;gBACE,UAAU;gBACV,4CAA4C;gBAC5C,wCAAkC;cACpC;;cAEA;gBACE,YAAY;gBACZ,6CAAuC;cACzC;YACF;;YAEA;;cAEE;gBACE,8CAAwC;cAC1C;;cAEA;gBACE,UAAU;gBACV,4CAA4C;gBAC5C,8BAA8B;;gBAE9B;;kBAEE,2CAA2C;gBAC7C;cACF;;cAEA;gBACE,4CAA4C;gBAC5C,gCAAgC;gBAChC,sCAAsC;gBACtC,6CAAuC;cACzC;;;;YAIF;UACF;QACF;;QAEA;UACE;YACE,oBAAoB;UACtB;QACF;MACF;IACF;EACF;;;EAGA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,8BAA8B;MAC9B,oBAAoB;IACtB;;IAEA;MACE,6BAA6B;MAC7B,gCAAgC;IAClC;;IAEA;MACE;QACE,sBAAsB;QACtB,uBAAuB;MACzB;IACF;EACF;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,sCAAsC;IACtC,eAAe;;IAEf;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB;IAC3B;;IAEA;MACE,SAAS;MACT,eAAe;MACf,gCAAgC;IAClC;EACF;AACF;;;;;;AAMA;EACE;IACE,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,gCAAgC;IAChC,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,gCAAgC;IAChC,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,uCAAuC;IACvC,gCAAgC;IAChC,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kCAAkC;EACpC;AACF;;;;;;;;;;;;;;;;;AAiBA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,gBAAgB;;EAEhB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;;IAEX;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,WAAW;MACX,YAAY;MACZ,eAAe;MACf,kBAAkB;;MAElB;QACE,WAAW;QACX,YAAY;QACZ,sCAAsC;QACtC,kBAAkB;MACpB;IACF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,uBAAuB;MACvB,QAAQ;;MAER;QACE,eAAe;QACf,gBAAgB;QAChB,yBAAyB;MAC3B;;MAEA;QACE,eAAe;QACf,0BAA0B;QAC1B,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;MACzB;IACF;;IAEA;MACE,mBAAmB;MACnB,uBAAuB;MACvB,QAAQ;MACR,oBAAoB;MACpB,sBAAsB;MACtB,iBAAiB;;MAEjB;QACE,eAAe;QACf,gBAAgB;QAChB,yBAAyB;MAC3B;;MAEA;QACE,oBAAoB;QACpB,mBAAmB;QACnB,yBAAyB;QACzB,WAAW;QACX,QAAQ;;QAER;UACE,WAAW;UACX,YAAY;QACd;;QAEA;UACE,oBAAoB;UACpB,mBAAmB;UACnB,uBAAuB;UACvB,QAAQ;UACR,4BAA4B;UAC5B,gBAAgB;UAChB,kBAAkB;UAClB,kBAAkB;UAClB,sCAAsC;;UAEtC;YACE,eAAe;YACf,gBAAgB;YAChB,gCAAgC;UAClC;;UAEA;YACE,gCAAgC;YAChC,WAAW;YACX,YAAY;UACd;QACF;MACF;IACF;EACF;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,WAAW;IACX,WAAW;IACX,qBAAqB;;IAErB;MACE,WAAW;MACX,kBAAkB;MAClB,gBAAgB;MAChB,yBAAyB;;MAEzB;QACE,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,uCAAuC;QACvC,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;MACrB;;MAEA;QACE,UAAU;QACV,yBAAyB;QACzB,uBAAuB;QACvB,kBAAkB;QAClB,UAAU;QACV,MAAM;QACN,UAAU;QACV,iDAAiD;QACjD,8CAAwC;QACxC,yCAAyC;QACzC,UAAU;QACV,6BAA6B;;MAE/B;;MAEA;QACE;UACE,aAAa;QACf;MACF;;;;MAIA;QACE,WAAW;QACX,YAAY;QACZ,eAAe;QACf,4CAA4C;QAC5C,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,gBAAgB;QAChB,gCAAgC;QAChC,sCAAsC;MACxC;;MAEA;QACE,aAAa;QACb,uBAAuB;QACvB,QAAQ;QACR,YAAY;QACZ,sBAAsB;QACtB,eAAe;;QAEf;UACE,eAAe;UACf,gBAAgB;UAChB,yBAAyB;UACzB,WAAW;UACX,mBAAmB;UACnB,gBAAgB;UAChB,uBAAuB;QACzB;;QAEA;UACE,eAAe;UACf,0BAA0B;UAC1B,WAAW;UACX,mBAAmB;UACnB,gBAAgB;UAChB,uBAAuB;QACzB;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,sCAAsC;QACtC,gCAAgC;QAChC,YAAY;QACZ,mBAAmB;;QAEnB;UACE,WAAW;UACX,eAAe;UACf,eAAe;UACf,YAAY;UACZ,kBAAkB;UAClB,sCAAsC;UACtC,mBAAmB;UACnB,2CAA2C;QAC7C;MACF;;;;;IAKF;EACF;;AAEF;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE;;;AAGF;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+CAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;IAEE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;;;AAIA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,WAAW;;IAEX;;MAEE,mBAAmB;MACnB,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,eAAe;MACf,eAAe;MACf,yBAAyB;MACzB,UAAU;MACV,YAAY;MACZ,kBAAkB;;MAElB;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,WAAW;;IAEX;MACE,kBAAkB;MAClB,WAAW;MACX,UAAU;MACV,eAAe;MACf,gBAAgB;IAClB;EACF;AACF;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,mCAAmC;EACnC,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,eAAe;MACf,SAAS;MACT,YAAY;IACd;;IAEA;MACE,eAAe;MACf,cAAc;MACd,eAAe;MACf,gBAAgB;IAClB;EACF;AACF;;AAEA,yDAAyD;AACzD;;EAEE,yBAAyB;EACzB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,kBAAkB;EACpB;;EAEA,2BAA2B;EAC3B;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,6BAA6B;EAC/B;;EAEA,+BAA+B;EAC/B;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;;IAEf;MACE,gBAAgB;MAChB,UAAU;MACV,gBAAgB;IAClB;EACF;;EAEA,oBAAoB;EACpB;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kCAAkC;;EAElC;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,sBAAsB;;IAEtB;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,sBAAsB;MACtB,WAAW;MACX,SAAS;MACT,YAAY;;MAEZ;QACE,gCAAgC;QAChC,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,QAAQ;QACR,UAAU;;QAEV;UACE,SAAS;UACT,gBAAgB;UAChB,qBAAqB;QACvB;;QAEA;UACE,mBAAmB;UACnB,YAAY;UACZ,YAAY;UACZ,iBAAiB;UACjB,kBAAkB;UAClB,eAAe;UACf,eAAe;UACf,gBAAgB;UAChB,sCAAsC;;UAEtC;YACE,mBAAmB;UACrB;QACF;MACF;;IAEF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,sBAAsB;MACtB,mBAAmB;MACnB,iBAAiB;MACjB,gBAAgB;;MAEhB;QACE,iBAAiB;MACnB;;MAEA,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;MACf,WAAW;MACX,yBAAyB;;;MAGzB;QACE,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,gCAAgC;QAChC,iBAAiB;QACjB,mBAAmB;QACnB,0CAA0C;QAC1C,UAAU;QACV,cAAc;;QAEd;UACE,WAAW;UACX,YAAY;QACd;MACF;;MAEA;QACE,iBAAiB;;QAEjB;UACE,iBAAiB;QACnB;;QAEA;UACE,yBAAyB;QAC3B;MACF;;;MAGA;QACE,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB,UAAU;MACZ;;MAEA;QACE;UACE,cAAc;QAChB;;QAEA;UACE,cAAc;QAChB;;QAEA;UACE,mBAAmB;QACrB;MACF;IACF;EACF;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,gBAAgB;MAChB,WAAW;;MAEX;QACE,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;;QAET;UACE,eAAe;UACf,gBAAgB;UAChB,qBAAqB;QACvB;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;QAC5B;MACF;IACF;EACF;AACF;;;;;;;;;;;;;;;;AAgBA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,+CAA+C;EAC/C,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,wBAAwB;EACxB,SAAS;EACT,SAAS;EACT,SAAS;AACX;;;AAGA;;EAEE;;;;;;IAME,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,cAAc;EAChB;;EAEA;;IAEE,sBAAsB;IACtB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;;IAEE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,6BAA6B;AAC7B;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;;EAEzB;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;;IAER;MACE,eAAe;MACf,YAAY;MACZ,2CAA2C;MAC3C,SAAO;IACT;;IAEA;MACE,aAAa;MACb,QAAQ;;MAER;QACE,gCAAgC;QAChC,YAAY;QACZ,0BAA0B;QAC1B,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,yBAAyB;;QAEzB;UACE,oCAAoC;UACpC,sBAAsB;QACxB;;QAEA;UACE,sBAAsB;QACxB;MACF;IACF;EACF;;EAEA;IACE;MACE,gBAAgB;MAChB,YAAY;MACZ,WAAW;;MAEX;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;;QAET;UACE,WAAW;UACX,YAAY;QACd;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,qBAAqB;QACvB;;QAEA;UACE,eAAe;UACf,gBAAgB;QAClB;MACF;IACF;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,6CAAuC;EACvC,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,+CAA+C;IAC/C,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 5;\n}\n\n.container {\n  display: flex;\n  height: 93vh;\n  margin: 0;\n  padding: 0;\n  /* background-color: var(--white-background); */\n  font-family: \"Inter\", serif;\n  position: relative;\n}\n\n/* .asideBar {\n  background: linear-gradient(0deg, var(--e9e9e96d-background) 21%, var(--f5-background) 100%);\n  height: 0px;\n  box-sizing: border-box;\n  top: 0;\n  z-index: 2;\n  transition: left 0.3s ease;\n  -webkit-transition: left 0.3s ease;\n  -moz-transition: left 0.3s ease;\n  -ms-transition: left 0.3s ease;\n  -o-transition: left 0.3s ease;\n  position: initial;\n  left: 0;\n  flex: 20;\n  padding: 0px 6px;\n} */\n\n/* .mobileMenu {\n  position: absolute;\n  width: 100vw;\n} */\n\n.offAsideBar {\n  left: -100%;\n}\n\n.chatSection {\n  display: flex;\n  align-items: flex-start;\n  height: 100vh;\n  width: 100%;\n  background: var(--f5-background);\n}\n\n.inputContainer {\n  width: 100%;\n\n  input[type=\"file\"] {\n    display: none;\n  }\n\n  label {\n    height: 100%;\n    width: 100%;\n    color: var(--_646e8a-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n}\n\n.footerChat {\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 10px 0;\n\n  span {\n    cursor: pointer;\n  }\n\n}\n\n.languageContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--_16c098-color);\n  flex-wrap: wrap;\n}\n\n.linksContainerFooterChat {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n\n  a {\n    color: var(--_9b-color);\n  }\n}\n\n.chatContainer {\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-direction: column;\n  height: 100%;\n  /* background: var(--f5-chatAdmin-background); */\n  /* border-radius: 20px; */\n\n  ul {\n    list-style-type: disc;\n    max-height: 100px;\n    overflow-y: scroll;\n    width: 100%;\n    padding-left: 10px;\n  }\n\n  .messageContainer::-webkit-scrollbar {\n    display: none;\n  }\n\n  .messageContainer {\n    width: 80%;\n    overflow-y: scroll;\n    max-height: calc(100% - 190px);\n    /* height: 70vh; */\n    height: 100%;\n    margin: 10px auto;\n    display: grid;\n    flex-direction: column;\n    gap: 10px;\n    display: flex;\n\n    .messageSettings {\n      text-align: center;\n      margin-top: 40px;\n      color: var(--_6-color);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 22px;\n    }\n\n    p {\n      margin: 0;\n    }\n\n    .initialMessage {\n      min-height: 60vh;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n\n      h2 {\n        margin: 0;\n        color: var(--_2-color);\n        text-align: center;\n        font-family: Inter;\n        font-size: clamp(20px, 5vw, 28px);\n        font-style: normal;\n        font-weight: 400;\n        line-height: 28px;\n        margin-top: 16px;\n      }\n    }\n\n    .facturaGPTLogo {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-top: 40px;\n\n      svg {\n        width: 200px;\n        stroke: var(--_10a37f-background);\n      }\n    }\n  }\n\n  .messageAutomateContainer {\n    height: 100%;\n  }\n\n}\n\n.chatContainerAgent {\n  max-height: calc(100vh - 55px);\n  margin: 0;\n  padding: 0;\n  overflow-y: clip;\n  box-sizing: border-box;\n}\n\n.chatTextContainer {\n  width: 100%;\n  bottom: 0px;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  /* background-color: var(--f5-chatAdmin-background); */\n}\n\n.chatTextContainerEnd {\n  justify-content: end;\n}\n\n.loading {\n  display: none;\n  position: absolute;\n  top: -3px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 30px;\n  width: 63%;\n  height: 3px;\n  background: linear-gradient(90deg,\n      transparent 0%,\n      var(--_16c098-background) 25%,\n      var(--_16c098-background) 75%,\n      transparent 100%);\n  background-size: 200% 100%;\n  animation: loading 2s infinite ease-in-out;\n  opacity: 0.8;\n  -webkit-animation: loading 2s infinite ease-in-out;\n\n  &.active {\n    display: block;\n  }\n}\n\n\n\n@keyframes loading {\n  0% {\n    background-position: -200% 0;\n  }\n\n  100% {\n    background-position: 200% 0;\n  }\n\n\n}\n\n.infoChunck {\n  position: absolute;\n  top: -30px;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n\n  >div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 15px;\n    background-color: var(--white-background);\n    padding: 5px 12px;\n    border-radius: 12px;\n    box-shadow: 0 4px 10px -4px var(--_0000001a-shadow);\n\n    span {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      font-size: 10px;\n\n      svg {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n\n  .upArrow {\n    transform: rotate(-45deg);\n    fill: var(--_8a-color);\n  }\n\n  .downArrow {\n    fill: var(--_8a-color);\n    transform: rotate(135deg);\n  }\n}\n\n\n\n.chatContainerBorderAnimation {\n  border: 4px solid rgba(0, 255, 0, 1);\n  animation: fadeBorder 2s infinite;\n}\n\n.chatTextAreaContainer {\n  width: 90%;\n  max-width: 600px;\n  background-color: var(--f4-chatAdmin-background);\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  padding-right: 4px;\n  margin: 0 auto;\n  justify-content: center;\n  border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n  -webkit-border-radius: 20px;\n  /* padding: 10px 20px; */\n  padding: 10px 10px 4px;\n  gap: 6px;\n  box-sizing: border-box;\n\n  border: 2px solid transparent;\n\n\n\n  @media (width<=768px) {\n    width: 80%;\n  }\n\n  .optionsChat {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    position: relative;\n\n\n    svg {\n      fill: var(--_2-color);\n      color: var(--_2-color);\n    }\n\n    .activeIcon {\n      fill: var(--_10a37f-background);\n      color: var(--_10a37f-background);\n\n    }\n\n    >div {\n      display: flex;\n      gap: 10px;\n      align-items: center;\n    }\n\n    div>button:nth-of-type(2) {\n      gap: 5px;\n      border-radius: 30px;\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n    }\n\n    div>button {\n      cursor: pointer;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      position: relative;\n      border: 1px solid var(--_00000036-border);\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      min-width: 32px;\n      height: 30px;\n      font-weight: 500;\n      background: var(--btn-chat-background);\n\n      svg {\n        fill: var(--_6-color);\n        color: var(--_6-color);\n      }\n\n      &:hover {\n        border: 1px solid var(--_10a37f-background);\n\n        svg {\n          fill: var(--_10a37f-background);\n          color: var(--_10a37f-background);\n        }\n      }\n\n\n      &::before {\n        content: attr(data-tooltip);\n        position: absolute;\n        top: calc(120% + 2px);\n        padding: 5px 10px;\n        background: var(--_000000cc-background);\n        color: var(--white-color);\n        border-radius: 4px;\n        font-size: 12px;\n        white-space: nowrap;\n        opacity: 0;\n        visibility: hidden;\n        transition: all 0.3s ease;\n\n      }\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: calc(100% - 2px);\n        left: 50%;\n        transform: translateX(-50%);\n        border: 5px solid transparent;\n        border-bottom-color: var(--_000000cc-background);\n        opacity: 0;\n        visibility: hidden;\n        transition: all 0.3s ease;\n      }\n\n      &:hover::before,\n      &:hover::after {\n        opacity: 1;\n        visibility: visible;\n      }\n\n      svg,\n      img {\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  textarea::-webkit-scrollbar {\n    display: none;\n  }\n\n  textarea {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n    outline: none;\n    border: none;\n    resize: none;\n    font-family: \"Inter\", serif;\n    color: var(--black-color);\n    font-size: 16px;\n  }\n\n  textarea::placeholder {\n    font-family: \"Inter\", serif;\n  }\n\n  .restartButton {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    color: var(--_9b-color);\n  }\n\n  .sendMessageBtn {\n    background-color: var(--_073f31-background);\n    height: 40px;\n    min-width: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n    outline: none;\n    border: none;\n  }\n\n  .sendMessageBtn[disabled] {\n    background: var(--_d7-background);\n    cursor: not-allowed;\n  }\n\n  .ArrowUp {\n    fill: var(--_6-color);\n    color: var(--_6-color);\n  }\n\n  .PauseIcon {\n    fill: var(--e6fff9-background);\n    color: var(--e6fff9-background);\n\n  }\n}\n\n@keyframes fadeBorder {\n  0% {\n    border-color: var(--_16c098-background);\n  }\n\n  50% {\n    border-color: transparent;\n  }\n\n  100% {\n    border-color: var(--_16c098-background);\n  }\n}\n\n@keyframes rogBgImg {\n  0% {\n    transform: rotate(0deg);\n    opacity: 1;\n    scale: 1;\n\n  }\n\n  50% {\n    opacity: 0;\n    scale: 0;\n  }\n\n  100% {\n    transform: rotate(180deg);\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n.errorAlert,\n.loading {\n  color: var(--_5d-color);\n  font-size: 12px;\n  text-align: center;\n\n  a {\n    color: var(--_073f31-color);\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 80%;\n  margin: 0 auto;\n  gap: 10px;\n  margin-bottom: 20px;\n  margin-top: 10px;\n\n  button {\n    background-color: var(--white-background);\n    color: var(--_67-color);\n    border: 1px solid var(--_00000036-border);\n    padding: 8px;\n    border-radius: 20px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: 768px) {\n  .buttonContainer {\n    button {\n      flex: 1;\n      font-size: 10px;\n      padding: 1px 6px;\n\n      svg {\n        height: 10px;\n        min-width: 10px;\n      }\n    }\n  }\n}\n\n.message {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 2px 14px;\n  width: 90%;\n\n  .avatar {\n    min-width: 40px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: var(--_16c09821-background);\n    color: var(--_16c098-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    font-weight: 600;\n  }\n\n  .avatarBot {\n    min-width: 26px;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    padding: 7px;\n    background: var(--_0000000a-background);\n  }\n}\n\n.isApp {\n  width: 100%;\n  background: transparent !important;\n  padding: 0px !important;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n\n  >p {\n    font-size: 14px;\n    /* background: var(--e6fff9-background); */\n    background: linear-gradient(135deg, #10a37f 0%, #16c098 100%);\n    padding: 10px;\n    line-height: 20px;\n    border-radius: 20px;\n    color: #fff;\n    flex-direction: column;\n    &.appHint {\n      background: linear-gradient(135deg, #414443 0%, #000000 100%);\n      border-radius: 20px 20px 0px 0px;\n      margin-bottom: -33px;\n      padding-bottom: 30px;\n    }\n  }\n}\n\n.isApi {\n  [class^=\"newTagHead\"] {\n    display: none;\n  }\n\n  [class^=\"container\"] {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    transform: none;\n    background: transparent;\n    border-radius: 0px;\n    background: var(--fe-background);\n  }\n\n  [class^=\"content\"] {\n    width: 100%;\n    box-shadow: none;\n    background: var(--f1f1f145-background);\n    padding: 10px;\n    margin-top: 10px;\n\n    [class^=\"input\"] {\n      background: var(--white-background);\n    }\n  }\n}\n\n.isAutomate {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n\n  >div {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--black--color);\n  }\n\n  ul {\n    list-style-type: disc;\n    padding: 0px 0px;\n    display: inline-flex;\n    flex-direction: column;\n    gap: 10px;\n    margin: 0px;\n  }\n\n  .automateVariable {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n\n    b {\n      font-size: 14px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      background: var(--1e293b-color);\n      color: var(--969595-fill);\n      border: 1px solid var(--f5-background);\n      border-radius: 6px;\n      padding: 2px 8px;\n      line-height: 22px;\n      font-weight: 500 !important;\n    }\n\n    p,\n    input {\n      font-size: 16px;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      margin: 0;\n      max-width: 100px;\n      border: 1px solid var(--f5-background);\n      background: var(--white-color);\n      border-radius: 8px;\n      padding: 2px 8px;\n      line-height: 24px;\n      color: var(--969595-fill);\n      outline: none;\n      border: none;\n    }\n\n    .buttonIcon {\n      width: 26px;\n      height: 20px;\n      background: transparent;\n      border: none;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n\n      svg {\n        width: 16px;\n        min-width: 16px;\n        height: 16px;\n      }\n    }\n\n    >div {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      button {\n        background: var(--white-background);\n        border: 1px solid var(--_00000036-border);\n        padding: 5px;\n        border-radius: 5px;\n        cursor: pointer;\n\n        &.saveButton {\n          background: #10a37f;\n          color: var(--white-color);\n          border: none;\n          font-size: 12px;\n          padding: 7px 10px;\n\n          &:hover {\n            background: var(--_073f31-background);\n            color: var(--white-color);\n          }\n        }\n      }\n    }\n  }\n\n  .automateCancelled {\n    background: #ff000040;\n    color: red;\n    padding: 0px 10px 0px 0px;\n    border-radius: 5px;\n    font-size: 16px;\n    line-height: 16px;\n    width: 100%;\n    text-align: end;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 24px 0px;\n    text-transform: uppercase;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  .automateItem {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 5px;\n    border-radius: 10px;\n    cursor: pointer;\n    background: var(--white-background);\n\n    .automateItemIcon {\n      width: 30px;\n      height: 30px;\n      min-width: 30px;\n      border-radius: 6px;\n      background-color: var(--_0000000a-background);\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 18px;\n      margin-left: -20px;\n      margin-top: 6px;\n    }\n\n    .automateItemContent {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n\n      b {\n        font-size: 14px;\n        line-height: 10px;\n        margin-top: 8px;\n      }\n\n      p {\n        font-size: 12px;\n        color: var(--_67-color);\n      }\n    }\n\n\n    &:hover {\n      background: var(--f5-background);\n\n      .automateItemIcon {\n        background: var(--f5-background);\n      }\n    }\n\n  }\n}\n\n.isAction {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n\n  &.big {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  &:not(.big) {\n    >div {\n      &:nth-of-type(1) {\n        margin-left: -56px;\n      }\n\n      &:nth-of-type(2) {\n        margin-left: -36px;\n      }\n\n      &:nth-of-type(3) {\n        margin-left: -12px;\n      }\n    }\n  }\n\n  >div {\n    background: var(--efefef-background);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 5px 16px 5px 6px;\n    border-radius: 10px;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease;\n\n    >div {\n      width: 14px;\n      height: 14px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 6px;\n      background: var(--white-background);\n      padding: 3px;\n      font-size: 13px;\n    }\n\n    span {\n      font-size: 10px;\n      font-weight: 500;\n    }\n\n    p {\n      font-size: 10px;\n      line-height: 14px;\n      font-weight: 400;\n      color: #515151;\n      position: absolute;\n      top: -140%;\n      left: 20px;\n      width: 100%;\n      max-width: 500px;\n      background: var(--white-background);\n      padding: 5px 10px 3px;\n      border-radius: 10px;\n      border: 1px solid var(--ed-background);\n      box-shadow: 0px 1px 7px -5px var(--_00000080-background);\n      transition: all 0.3s ease;\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    &:hover {\n      background: var(--white-background);\n\n      p {\n        display: block;\n        opacity: 1;\n        visibility: visible;\n      }\n    }\n  }\n}\n\n.isImage {\n  background: #f5f5f5;\n  padding: 10px;\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n  max-width: 350px;\n  display: flex;\n  align-items: center;\n\n  img {\n    border-radius: 10px;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.isTable {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--_3c3a3a-color);\n    font-weight: 400;\n  }\n}\n\n\n.messageUserContainer {\n  display: flex;\n  justify-content: end;\n  flex-direction: column;\n  align-items: end;\n}\n\n.messageUserContainer,\n.botMessage {\n  .optionsBtnMessage {\n    padding-right: 40px;\n    opacity: 0;\n    transition: all 150ms;\n    -webkit-transition: all 150ms;\n    -moz-transition: all 150ms;\n    -ms-transition: all 150ms;\n    -o-transition: all 150ms;\n  }\n\n  &:hover {\n    .optionsBtnMessage {\n      opacity: 1;\n    }\n  }\n}\n\n.userMessage {\n  text-align: right;\n  justify-content: flex-end;\n  height: fit-content;\n\n  .fileContainerMessage {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px;\n    background-color: var(--_0a785d6d-background);\n    border-radius: 16px;\n    -webkit-border-radius: 16px;\n    -moz-border-radius: 16px;\n    -ms-border-radius: 16px;\n    -o-border-radius: 16px;\n    width: 100%;\n    box-sizing: border-box;\n\n    p {\n      margin: 0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .iconFileContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--_10a37f-background);\n    padding: 8px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    width: fit-content;\n  }\n\n  .userMessageContainer {\n    font-size: 14px;\n    background: var(--e6fff9-background);\n    padding: 10px;\n    line-height: 20px;\n    border-radius: 20px;\n    color: var(--_1e-color);\n    display: flex;\n    max-width: 400px;\n    flex-direction: column;\n\n    .date {\n      color: var(--_5d-color);\n      font-size: 10px;\n      text-align: end;\n    }\n\n    .messageText {}\n  }\n}\n\n.botMessage {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n\n  .message {\n    >div {\n      font-size: 14px;\n      background: var(--f9-background);\n      /* padding: 20px 10px; */\n      padding: 10px;\n      line-height: 22px;\n      border-radius: 20px;\n      color: var(--_3c3a3a-color);\n      /* white-space: pre-wrap; */\n      /* word-wrap: break-word; */\n    }\n  }\n}\n\n/* .chatMenu {\n  background: var(--white-background);\n  height: 100%;\n  width: 100%;\n  min-width: 200px;\n\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n\n  .chatsContainer {\n    height: calc(100% - 126px);\n    overflow-y: auto;\n    padding: 10px 0px;\n    box-sizing: border-box;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    h3 {\n      font-weight: 600;\n      margin: 0;\n      font-size: 10px;\n      color: var(--black-color);\n    }\n\n    span {\n      font-weight: 600;\n      margin: 0;\n      font-size: 10px;\n      color: var(--_8a-color);\n      padding: 5px 0;\n      text-align: center;\n    }\n\n    .noFilesContainer {\n\n      h3,\n      h4 {\n        max-width: 95%;\n        font-size: 15px;\n        text-align: center;\n        font-weight: 600;\n        color: var(--_67-color);\n      }\n    }\n\n    ul {\n      padding-left: 0px;\n      margin: 2px 0px;\n      display: inline-flex;\n      flex-direction: column;\n      gap: 8px;\n      width: 100%;\n\n      li {\n        list-style: none;\n        position: relative;\n        padding: 8px;\n        font-size: 12px;\n        border-radius: 12px;\n        -webkit-border-radius: 12px;\n        -moz-border-radius: 12px;\n        -ms-border-radius: 12px;\n        -o-border-radius: 12px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 5px;\n        height: 20px;\n\n        &:hover {\n          background-color: var(--ececf1-background);\n\n          .pinnedIcon {\n            display: none;\n\n          }\n\n          .chatMenuSettings {\n            display: block;\n          }\n        }\n\n        input {\n          background-color: transparent;\n          border: none;\n          outline: none;\n        }\n\n        .selectedChat {\n          background: transparent;\n          font-weight: 600;\n          font-size: 10px;\n          color: var(--_8a-color);\n        }\n      }\n\n      .icon {\n        opacity: 0;\n      }\n\n      .moreButton {\n        display: none;\n        border: none;\n        background: none;\n        padding: 4px;\n        cursor: pointer;\n        opacity: 0;\n        align-items: center;\n        justify-content: center;\n        transition: opacity 0.2s ease-in-out;\n        margin-left: auto;\n\n        img {\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      li:hover .moreButton {\n        opacity: 0.7;\n        display: flex;\n      }\n\n      .moreButton:hover {\n        opacity: 1 !important;\n        background: var(--ea-background);\n        border-radius: 4px;\n      }\n\n      li:hover .icon {\n        opacity: 1;\n      }\n\n      .agentInfo {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        min-width: 70%;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n\n        .agentNameQuantityConversations {\n          display: flex;\n          flex-direction: column;\n\n          span {\n            padding: 0;\n          }\n        }\n      }\n\n      .pinnedIcon {\n        display: block;\n\n\n        svg {\n          fill: var(--_2-color);\n          color: var(--_2-color);\n          height: 15px;\n          width: 15px;\n        }\n\n        .pinnedIconSvg {\n          fill: var(--_10a37f-background);\n          color: var(--_10a37f-background);\n        }\n      }\n\n      img {\n        width: 32px;\n        height: 32px;\n        border-radius: 999px;\n        -webkit-border-radius: 999px;\n        -moz-border-radius: 999px;\n        -ms-border-radius: 999px;\n        -o-border-radius: 999px;\n      }\n    }\n\n    .active {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n@media (width <=768px) {\n  .chatMenu {\n    .chatsContainer {\n      height: 65vh;\n    }\n  }\n\n  .searchInputWrapper {\n    display: flex;\n    align-items: center;\n    background: var(--white-background);\n    height: 36px;\n    min-height: 36px;\n    border: 1px solid var(--d9d9e3-border);\n    border-radius: 8px;\n    padding: 0px 9px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    width: 100%;\n\n    .searchIcon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 24px;\n      height: 24px;\n      color: var(--_6-color);\n    }\n\n    .searchInput {\n      flex: 1;\n      padding: 8px;\n      border: none;\n      background: transparent;\n      font-size: 14px;\n      outline: none;\n      width: 100%;\n\n      &::placeholder {\n        color: var(--_6-color);\n      }\n    }\n  }\n}\n\n.chatMenuSettings { \n  display: none;\n\n  button {\n    background-color: transparent;\n    outline: none;\n    border: none;\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    right: 5px;\n    transform: translateY(-50%);\n  }\n\n  .verticalDots {\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n  }\n} */\n\n/* .menuOptions {\n  flex-direction: column;\n  gap: 10px;\n  list-style: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  top: 23px;\n  z-index: 999;\n  padding: 4px;\n  border-radius: 8px;\n  background: var(--fa-background);\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n\n  li {\n    border-radius: 10px;\n    background: var(--white-background);\n    padding: 8px 16px;\n    cursor: pointer;\n    text-align: left;\n    font-size: 14px;\n    color: var(--_3-color);\n    border-radius: 4px;\n\n    &:hover {\n      background-color: var(--f5-background);\n    }\n\n    .chatMenuSettingsIcon {\n      position: relative;\n\n      button {\n        width: 16px;\n        height: 16px;\n        color: var(--black-color);\n        cursor: pointer;\n\n\n      }\n\n      ul {\n        display: none;\n        flex-direction: column;\n        gap: 10px;\n        list-style: none;\n\n        li {\n          padding: 10px;\n          border-radius: 10px;\n          background: var(--white-background);\n          cursor: pointer;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n} */\n\n/* .searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n} */\n\n/* .searchContainerL {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 4px 0px;\n  cursor: pointer;\n\n  img {\n    transition: filter 0.1s ease;\n    -webkit-transition: filter 0.1s ease;\n    -moz-transition: filter 0.1s ease;\n    -ms-transition: filter 0.1s ease;\n    -o-transition: filter 0.1s ease;\n  }\n} */\n\n\n\n/* .noChats {\n  flex: 1 1;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: var(--_3a-color);\n  gap: 10px;\n  font-weight: 600;\n  justify-content: center;\n  padding-top: 0;\n  height: 93%;\n  text-align: center;\n  border: 2px dashed var(--d9d9e3-border);\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    max-width: 95%;\n    font-size: 15px;\n    text-align: center;\n    font-weight: 600;\n    color: var(--_67-color);\n  }\n} */\n\n.recommendesQuestionsContainer {\n  position: absolute;\n  width: 100%;\n  bottom: calc(100% - 5px);\n  left: 0;\n  max-height: 200px;\n  overflow-y: scroll;\n\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.textBlack {\n  color: var(--black-color);\n}\n\n.recommendesQuestionsContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.recomendQuestions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n\n  overflow: hidden;\n\n  >div {\n    display: flex;\n    padding: 11px 9px;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    align-self: stretch;\n    border: 1px solid var(--d9d9e3-border);\n    background: var(--white-background);\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: var(--fa-background);\n    }\n\n    P {\n      margin: 0;\n      color: var(--_71-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n    }\n\n    svg {\n      height: 15px;\n      width: 15px;\n    }\n\n    &:first-child {\n      border-radius: 8px 8px 0 0;\n      -webkit-border-radius: 8px 8px 0 0;\n      -moz-border-radius: 8px 8px 0 0;\n      -ms-border-radius: 8px 8px 0 0;\n      -o-border-radius: 8px 8px 0 0;\n    }\n  }\n}\n\n\n\n\n\n.chatContainerPage {\n  overflow-y: auto;\n  height: 100vh;\n  background: var(--white-background);\n  border-radius: 20px 0 0 0px !important;\n  /* border: 1px solid var(--ececf1-border); */\n  width: 100%;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n\n  &.hidden {\n    display: none;\n  }\n}\n\n.chatAutomate {\n  /* height: calc(100vh - 290px); */\n  height: 100%;\n  overflow: clip;\n}\n\n/* .goToAgents {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n\n  &:hover {\n    .chatMenuSettings {\n      display: block;\n    }\n\n    .pinnedIcon {\n      display: none;\n    }\n\n    .selectedAgentContainer {\n      padding-right: 12px;\n    }\n  }\n\n  .selectedAgentContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n\n  img {\n    height: 25px;\n    width: 25px;\n    border-radius: 999px;\n    -webkit-border-radius: 999px;\n    -moz-border-radius: 999px;\n    -ms-border-radius: 999px;\n    -o-border-radius: 999px;\n  }\n\n  .verticalDots {\n    height: 20px;\n    width: 20px;\n    margin-right: -12px;\n  }\n} */\n\n.iconContainer {\n  border: none;\n  outline: none;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 4px;\n  display: flex;\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  box-sizing: border-box;\n  height: 25px;\n  width: 25px;\n  pointer-events: all;\n}\n\n.fileContainer {\n  width: fit-content;\n  background-color: var(--white-background);\n  padding: 4px;\n  box-sizing: border-box;\n  display: flex;\n  gap: 8px;\n  margin: 4px 0 10px;\n  border: 1px solid #cacaca;\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  min-width: 200px;\n  max-width: 380px;\n  position: relative;\n  align-items: center;\n\n  .iconFileContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--_10a37f-background);\n    padding: 8px;\n    max-width: 22px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n  }\n\n  svg {\n    height: 20px;\n    min-width: 20px;\n    fill: var(--white-background);\n  }\n\n  >div {\n    overflow: hidden;\n\n    p {\n      margin: 0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    span {\n      text-transform: uppercase;\n      font-size: 13px;\n      color: var(--_71-color);\n    }\n  }\n\n  .deleteFileButton {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: -5px;\n    right: -5px;\n    background-color: var(--_3a-background);\n    color: var(--white-color);\n    font-size: 8px;\n    height: 15px;\n    min-width: 15px;\n    border-radius: 999px;\n    -webkit-border-radius: 999px;\n    -moz-border-radius: 999px;\n    -ms-border-radius: 999px;\n    -o-border-radius: 999px;\n    cursor: pointer;\n  }\n}\n\n.agentsContainer {\n  height: 94%;\n}\n\n/* .noFilesContainer {\n  flex: 1;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border: 2px dashed var(--d9d9e3-border);\n\n  color: var(--_67-color);\n  gap: 10px;\n  font-weight: 600;\n  cursor: grab;\n  height: 100%; \n\n  h3,\n  h4 {\n    max-width: 85%;\n    font-size: 26px;\n    text-align: center;\n    font-weight: 600;\n    color: var(--_67-color);\n  }\n\n  svg {\n    max-width: 110px;\n    height: 110px;\n    width: 70px;\n    color: var(--_e6-color) !important;\n  }\n} */\n\n\n\n.dateSeparatorContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.lineBreak {\n  display: none;\n}\n\n.singleLine {\n  display: none;\n}\n\n@media screen and (min-width: 1045px) {\n  .lineBreak {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 1044px) {\n  .singleLine {\n    display: block;\n  }\n}\n\n/* \n.dotsWrapperHover {}\n\n.dotsWrapperHover:hover {\n  .shadowContainer {\n    opacity: 1;\n  }\n} */\n\n\n/* .shadowContainer {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  margin-left: 6px;\n  width: 15px;\n  height: 27px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n} */\n/* \n.dotsWrapperHoverHorizontal {}\n\n.dotsWrapperHoverHorizontal:hover {\n  .shadowContainerHorizontal {\n    opacity: 1;\n  }\n}\n\n\n.shadowContainerHorizontal {\n  background-color: var(--_52525261-background);\n  transition: all 300ms;\n  margin-top: -2px;\n  width: 27px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 300ms;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n} */\n\n.highlight {\n  position: absolute;\n  width: 90%;\n  z-index: 1;\n  font-size: 16px;\n  top: 13px;\n  left: 12px;\n  pointer-events: none;\n  font-family: \"Inter\", serif;\n  color: transparent;\n}\n\n\n.replyContainer {\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n\n  >div {\n    display: flex;\n    gap: 0px;\n    flex-direction: column;\n    width: 100%;\n    background: #cdece4;\n    padding: 8px;\n    border-radius: 6px;\n    border-left: 4px solid #16c098;\n    margin-bottom: 8px;\n    text-align: left;\n\n    b {\n      font-size: 16px;\n      font-weight: 600;\n      color: #16c098;\n    }\n\n    p {\n      font-size: 16px;\n      color: var(--_71-color);\n      margin: 0;\n      line-height: 22px;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: var(--_71-color);\n\n    svg {\n      width: 22px;\n      height: 22px;\n    }\n  }\n}\n\n.viewerSection {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .viewerContainerSearch {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 10px;\n    flex-direction: column;\n\n    p {\n      line-height: 16px;\n      font-size: 14px;\n      font-weight: 600;\n      color: var(--_71-color);\n    }\n\n    div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      padding: 6px 10px;\n      border-radius: 6px;\n      background: #f4f4f4;\n\n      svg {\n        width: 14px;\n        height: 14px;\n      }\n\n      input {\n        border: none;\n        outline: none;\n        background: transparent;\n        font-size: 22px;\n        font-weight: 600;\n        color: var(--_71-color);\n\n        &::placeholder {\n          color: var(--_71-color);\n        }\n      }\n    }\n  }\n\n  .viewerContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-end;\n\n    .viewerContainerHeader {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 10px;\n      background: #f4f4f4;\n      padding: 8px 16px 8px 8px;\n      border-radius: 8px;\n      cursor: pointer;\n      transition: all 300ms;\n\n      &:hover {\n        background: transparent;\n        transform: scale(1.02);\n      }\n    }\n\n    .viewerContainerAvatar {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      background: var(--_10a37f-background);\n      padding: 8px;\n      border-radius: 8px;\n      width: 110px;\n      height: 110px;\n      min-width: 110px;\n      color: #fff;\n      font-size: 38px;\n      font-weight: 600;\n    }\n\n    .viewerContainerInfo {\n      display: flex;\n      align-items: flex-start;\n      justify-content: center;\n      gap: 4px;\n      flex-direction: column;\n\n      b {\n        font-size: 20px;\n        font-weight: 600;\n        color: #000000;\n      }\n\n      span {\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--_71-color);\n      }\n\n      .viewerContainerStats {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        margin-top: -4px;\n\n        label {\n          margin: 0px;\n          font-size: 14px;\n          font-weight: 600;\n          color: var(--_71-color);\n        }\n      }\n\n      .viewerContainerLabel {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 10px;\n        width: 100%;\n\n        div {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 6px;\n          background: #ffffff;\n          color: #454343;\n          padding: 2px 6px 2px 10px;\n          font-size: 12px;\n        }\n      }\n\n      .viewerContainerLabelBottom {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 10px;\n        width: 100%;\n\n        span {\n          font-size: 12px;\n          font-weight: 600;\n          color: var(--_71-color);\n        }\n      }\n    }\n\n    .viewerContainerStatus {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      label {\n        background: var(--_10a37f-background);\n        font-size: 12px;\n        font-weight: 600;\n        color: #ffffff;\n        margin: 0px;\n        padding: 2px 4px;\n        border-radius: 12px;\n      }\n    }\n\n    .viewerContainerButtons {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      button {\n        font-size: 14px;\n        font-weight: 600;\n        color: var(--_71-color);\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        padding: 8px;\n        background: #e0e0e0;\n        border: none;\n        border-radius: 8px;\n\n        &.active {\n          background: var(--_10a37f-background);\n          color: #fff;\n        }\n\n        &.second {\n          background: #f4f4f4;\n          border: 1px solid #e1e1e1;\n        }\n      }\n\n      .viewerContainerButtonsDot {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: var(--_10a37f-background);\n      }\n\n    }\n\n    .viewerContainerTags {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      .viewerContainerTagsItem {\n        background: #fff;\n        padding: 4px 5px;\n        font-size: 12px;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        border-radius: 6px;\n        display: inline-flex;\n\n        svg {\n          cursor: pointer;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n\n    .viewerContainerActions {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n\n      button {\n        width: 35px;\n        height: 35px;\n        color: var(--_71-color);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        border-radius: 50%;\n        border: 1px solid #c6c6c6;\n        background: transparent;\n        cursor: pointer;\n\n        svg {\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n}\n\n\n.arrobaText {\n  color: var(--_10a37f-background);\n  pointer-events: auto;\n  cursor: pointer;\n  position: relative;\n  font-size: 16px;\n  top: -1px;\n  z-index: 99;\n  position: relative;\n}\n\n.mentionWrapper {\n  display: inline-block;\n  position: relative;\n\n  /* background: #cdece4;\n  left: 0px;\n  top: -2px;\n  padding: 2px 10px;\n  border-radius: 10px; */\n  &:before {\n    display: block;\n    content: \"\";\n    position: absolute;\n    left: -2px;\n    top: -2px;\n    border-radius: 22px;\n    width: calc(100% + 6px);\n    height: calc(100% + 4px);\n    background: #ccebe3;\n    z-index: -1;\n  }\n}\n\n\n.mentionWrapper :global(.miniProfileModal) {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 10;\n  display: none;\n}\n\n.mentionWrapper:hover :global(.miniProfileModal) {\n  display: block;\n}\n\n.liSinHover {\n  all: unset;\n  display: list-item;\n}\n\n.liSinHover:hover {\n  background-color: inherit !important;\n  color: inherit !important;\n  cursor: default !important;\n}\n\n/* .groupTitle {\n  font-size: 12px;\n  padding: 8px;\n  color: var(--black-color);\n  background-color: var(--f4-background);\n} */\n\n\n\n.messageDrag {\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: center;\n  background: var(--white-background);\n  border-radius: 20px 0 0 0;\n  position: relative;\n\n  &.hidden {\n    display: none;\n  }\n\n  .messageDragContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 10px;\n    min-width: 600px;\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 20px;\n    height: calc(100% - 90px);\n    width: 100%;\n\n    .messageDragAgent {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      justify-content: flex-start;\n      gap: 10px;\n      overflow-y: auto;\n      height: 100%;\n      padding: 0 2px;\n      position: relative;\n\n      .messageDragAgentItemClose {\n        display: none;\n        position: absolute;\n        top: 10px;\n        right: 20px;\n        font-size: 14px;\n        font-weight: 600;\n        color: #494949;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        transition: all 300ms;\n        padding: 0;\n        margin: 0;\n        outline: none;\n\n        &:hover {\n          color: var(--black-color);\n        }\n      }\n\n      &.loadedAgent {\n        .messageDragAgentItem {\n          border: 2px dashed var(--_16c098-background) !important;\n          background: var(--cdece445-background) !important;\n        }\n\n        .messageDragAgentItemHeader {\n          display: grid !important;\n          grid-template-columns: 40px auto;\n          align-items: flex-start !important;\n\n          .messageDragAgentItemHeaderTags {\n            width: fit-content;\n          }\n\n          .messageDragAgentItemHeaderIcon {\n\n            img {\n              width: 34px !important;\n              min-width: 34px !important;\n              height: 34px !important;\n              border: 1px solid var(--f5-background);\n\n            }\n          }\n\n          .messageDragAgentItemHeaderContent {\n            align-items: flex-start !important;\n            gap: 5px !important;\n\n            b {\n              color: var(--_16c098-background) !important;\n              font-weight: 800 !important;\n            }\n\n            p {\n              color: var(--_16c098-background) !important;\n              font-weight: 600 !important;\n            }\n          }\n\n          .messageDragAgentItemHeaderTags {\n            display: none !important;\n            opacity: 0;\n          }\n        }\n\n        .messageDragAgentItemList {\n          .messageDragAgentItemListNumber {\n            border: 2px dashed var(--_16c098-background) !important;\n            color: var(--_16c098-background) !important;\n            background: var(--cdece445-background) !important;\n            animation: backgroundChange 2s forwards !important;\n          }\n        }\n\n      }\n\n      &.loadingMessage {\n        .messageDragAgentItem {\n          animation: borderPulse 1s infinite;\n        }\n\n        .messageDragAgentItemClose {\n          display: inline-flex;\n        }\n      }\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n\n\n\n      .messageDragAgentItemAlert {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        gap: 10px;\n        width: 100%;\n\n        b {\n          font-size: 18px;\n          font-weight: 600;\n          color: var(--black-color);\n          text-align: center;\n        }\n\n        p {\n          font-size: 14px;\n          font-weight: 400;\n          color: var(--black-color);\n          text-align: center;\n          margin: 0px 0px 10px;\n        }\n\n        .messageDragAgentItemAlertTags {\n          display: inline-flex;\n          flex-wrap: wrap;\n          align-items: center;\n          justify-content: center;\n          gap: 10px;\n          width: 100%;\n\n          .messageDragAgentItemAlertTag {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 10px;\n            border: 1px solid #f2eaea;\n            padding: 4px 10px;\n            border-radius: 10px;\n            background: var(--f5f5f569-background);\n            width: 100%;\n            margin: 0px;\n            color: #c6c6c6;\n            transition: all 300ms;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            width: auto;\n\n            &:hover {\n              background: var(--f5f5f538-background);\n            }\n          }\n        }\n\n\n        .messageDragAgentItemAlertButtons {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 10px;\n\n          button {\n            font-size: 16px;\n            font-weight: 600;\n            color: var(--black-color);\n            text-align: center;\n            background: transparent;\n            border: none;\n            border-radius: 6px;\n            border: 1px solid #e2e2e2;\n            padding: 10px 20px;\n            border-radius: 8px;\n            cursor: pointer;\n            transition: all 300ms;\n\n            &:hover {\n              background: var(--_16c098-background);\n              color: #fff;\n            }\n\n            &.importButton {\n              background: var(--_16c098-background);\n              color: #fff;\n            }\n          }\n        }\n      }\n\n      &.loadedAgent {\n        .messageDragAgentItemAlert {\n          display: block;\n          opacity: 1;\n        }\n\n        .messageDragAgentItemClose {\n          display: none;\n        }\n      }\n\n      .messageDragAgentItem {\n        position: relative;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        justify-content: center;\n        gap: 10px;\n        width: 93%;\n        border: 2px dashed var(--ea-background);\n        background: var(--_f5f5f569-background);\n        border-radius: 10px;\n        padding: 10px;\n        cursor: pointer;\n        transition: all 300ms;\n\n        &:hover {\n          background: var(--white-background);\n        }\n\n        .messageDragAgentItemHeader {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n          width: 100%;\n\n          .messageDragAgentItemHeaderIcon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 28px;\n\n            img {\n              border-radius: 50%;\n              border: 1px solid var(--f5-background);\n              width: 46px;\n              height: 46px;\n              min-width: 46px;\n            }\n          }\n\n          .messageDragAgentItemHeaderContent {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: center;\n            gap: 0px;\n\n            b {\n              font-size: 14px;\n              font-weight: 600;\n              color: var(--black-color);\n            }\n\n            p {\n              font-size: 12px;\n              color: var(--595959-color);\n              margin: 0px;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n          }\n\n          .messageDragAgentItemHeaderTags {\n            align-items: center;\n            justify-content: center;\n            gap: 5px;\n            display: inline-flex;\n            flex-direction: column;\n            margin-left: auto;\n\n            b {\n              font-size: 10px;\n              font-weight: 600;\n              color: var(--black-color);\n            }\n\n            div {\n              display: inline-flex;\n              align-items: center;\n              justify-content: flex-end;\n              gap: 6px;\n\n              svg {\n                width: 14px;\n                height: 14px;\n                min-width: 14px;\n              }\n\n              .messageDragAgentItemHeaderTagsLabel {\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                gap: 5px;\n                background: var(--e5-border);\n                padding: 3px 5px;\n                border-radius: 6px;\n                width: fit-content;\n                background: var(--16c09829-background);\n\n                span {\n                  font-size: 12px;\n                  font-weight: 600;\n                  color: var(--_16c098-background);\n                }\n\n                svg {\n                  color: var(--_16c098-background);\n                  width: 12px;\n                  height: 12px;\n                }\n              }\n            }\n          }\n        }\n\n        .messageDragAgentItemList {\n          display: none;\n          padding: 0px;\n          flex-direction: column;\n          align-items: flex-start;\n          justify-content: flex-start;\n          gap: 10px;\n          max-width: 450px;\n          width: 100%;\n          margin: 0px;\n          transition: all 300ms;\n          opacity: 0;\n\n          &.showList,\n          &:hover {\n            display: inline-flex !important;\n            opacity: 1 !important;\n            zoom: 1.2;\n          }\n\n          &.isLoading {\n            zoom: 1 !important;\n          }\n\n\n          li {\n            width: 100%;\n            position: relative;\n            list-style: none;\n            transition: all 0.3s ease;\n\n            .messageDragAgentItemListContainer {\n              opacity: 0.6;\n              position: relative;\n              display: flex;\n              align-items: center;\n              gap: 8px;\n              border: 2px dashed var(--f5f5f538-background);\n              padding: 5px 12px 6px 8px;\n              background: #fff;\n              border-radius: 12px;\n            }\n\n            .loadingBar {\n              width: 4px;\n              height: calc(100% + 10px);\n              background: transparent;\n              position: absolute;\n              left: 20px;\n              top: 0;\n              z-index: 0;\n              border-right: 2px dashed var(--_16c098-background);\n              animation-fill-mode: forwards;\n              opacity: 0;\n            }\n\n            &:last-child {\n              .loadingBar {\n                display: none;\n              }\n            }\n\n\n\n            .messageDragAgentItemListNumber {\n              width: 26px;\n              height: 26px;\n              min-width: 26px;\n              border: 2px dashed var(--f5-background);\n              border-radius: 50%;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              font-size: 12px;\n              font-weight: 600;\n              color: #989898;\n              background: var(--f4-background);\n\n            }\n\n\n            .messageDragAgentItemListContent {\n              display: flex;\n              justify-content: center;\n              gap: 3px;\n              height: 100%;\n              flex-direction: column;\n              margin: 2px 0px;\n\n              p {\n                font-size: 16px;\n                font-weight: 600;\n                color: var(--black-color);\n                margin: 0px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n\n              span {\n                font-size: 12px;\n                color: var(--_3a-color);\n                margin: 0;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n\n            .messageDragAgentItemListTags {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              font-size: 10px;\n              font-weight: 500;\n              margin-left: auto;\n              margin-right: 5px;\n              background: #16c098;\n              color: #fff;\n              padding: 5px;\n              border-radius: 12px;\n\n\n            }\n\n            &.pending {\n              .messageDragAgentItemListContainer {\n                opacity: 1;\n                border: 2px dashed var(--_16c098-background);\n                animation: borderPulse 1s infinite;\n              }\n\n              .messageDragAgentItemListNumber {\n                border: none;\n                animation: backgroundPulse1 2s infinite;\n              }\n            }\n\n            &.active {\n\n              .loadingBar {\n                animation: loadingBar 1.2s ease forwards;\n              }\n\n              .messageDragAgentItemListContainer {\n                opacity: 1;\n                border: 2px dashed var(--_16c098-background);\n                background: #f1faf8 !important;\n\n                p,\n                span {\n                  color: var(--_16c098-background) !important;\n                }\n              }\n\n              .messageDragAgentItemListNumber {\n                border: 2px dashed var(--_16c098-background);\n                color: var(--_16c098-background);\n                background: var(--cdece445-background);\n                animation: backgroundChange 2s forwards;\n              }\n\n\n\n            }\n          }\n        }\n\n        &:hover {\n          .messageDragAgentItemList {\n            display: inline-flex;\n          }\n        }\n      }\n    }\n  }\n\n\n  .messageDragAgent.big {\n    .messageDragAgentItem {\n      height: 100% !important;\n    }\n\n    .messageDragAgentItemHeader {\n      flex-direction: column !important;\n    }\n\n    .messageDragAgentItemHeaderContent {\n      align-items: center !important;\n      gap: 10px !important;\n    }\n\n    .messageDragAgentItemHeaderTags {\n      margin-left: unset !important;\n      flex-direction: unset !important;\n    }\n\n    .messageDragAgentItemHeaderIcon {\n      svg {\n        width: 30px !important;\n        height: 30px !important;\n      }\n    }\n  }\n\n\n  .messageDragAttachment {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 100%;\n    height: -webkit-fill-available;\n    border-radius: 10px;\n    border: 2px dashed var(--_16c098-background);\n    padding: 10px;\n    background: var(--cdece445-background);\n    cursor: pointer;\n\n    svg {\n      width: 60px;\n      height: 60px;\n      color: var(--16C097-fill);\n    }\n\n    p {\n      margin: 0;\n      font-size: 20px;\n      color: var(--_16c098-background);\n    }\n  }\n}\n\n\n\n\n\n@keyframes backgroundChange {\n  0% {\n    background: var(--cdece445-background);\n    color: #fff;\n  }\n\n  100% {\n    background: var(--_16c098-background);\n    color: #fff;\n  }\n}\n\n@keyframes backgroundPulse1 {\n  0% {\n    background: var(--_16c0982e-background);\n    color: var(--_16c098-background);\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    background: #f1faf8 !important;\n    color: var(--_16c098-background);\n    opacity: 0.7;\n    transform: scale(1.10);\n  }\n\n  100% {\n    background: var(--_16c0982e-background);\n    color: var(--_16c098-background);\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes loadingBar {\n  0% {\n    transform: scaleY(0);\n    transform-origin: top;\n    opacity: 1;\n  }\n\n  100% {\n    transform: scaleY(1);\n    transform-origin: top;\n    opacity: 1;\n  }\n}\n\n@keyframes borderPulse {\n  0% {\n    border-color: var(--f5-background);\n  }\n\n  50% {\n    border-color: var(--e0-border);\n  }\n\n  100% {\n    border-color: var(--f5-background);\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.messageAutomateItem {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  width: 93%;\n  cursor: pointer;\n  transition: all 300ms;\n  max-width: 460px;\n\n  .messageAutomateItemHeader {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n\n    .messageAutomateItemHeaderIcon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      width: 36px;\n      height: 36px;\n      min-width: 36px;\n      border-radius: 50%;\n\n      img {\n        width: 40px;\n        height: 40px;\n        border: 1px solid var(--f5-background);\n        border-radius: 50%;\n      }\n    }\n\n    .messageAutomateItemHeaderContent {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: center;\n      gap: 2px;\n\n      b {\n        font-size: 20px;\n        font-weight: 600;\n        color: var(--black-color);\n      }\n\n      p {\n        font-size: 12px;\n        color: var(--595959-color);\n        margin: 0px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .messageAutomateItemHeaderTags {\n      align-items: center;\n      justify-content: center;\n      gap: 5px;\n      display: inline-flex;\n      flex-direction: column;\n      margin-left: auto;\n\n      b {\n        font-size: 10px;\n        font-weight: 600;\n        color: var(--black-color);\n      }\n\n      div {\n        display: inline-flex;\n        align-items: center;\n        justify-content: flex-end;\n        width: 100%;\n        gap: 6px;\n\n        svg {\n          width: 14px;\n          height: 14px;\n        }\n\n        .messageAutomateItemHeaderTagsLabel {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          gap: 5px;\n          background: var(--e5-border);\n          padding: 3px 5px;\n          border-radius: 6px;\n          width: fit-content;\n          background: var(--16c09829-background);\n\n          span {\n            font-size: 12px;\n            font-weight: 600;\n            color: var(--_16c098-background);\n          }\n\n          svg {\n            color: var(--_16c098-background);\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n    }\n  }\n\n  .messageAutomateItemList {\n    padding: 0px;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 10px;\n    height: 100%;\n    width: 100%;\n    margin: 0px;\n    transition: all 300ms;\n\n    li {\n      width: 100%;\n      position: relative;\n      list-style: none;\n      transition: all 0.3s ease;\n\n      .messageAutomateItemListContainer {\n        position: relative;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        border: 2px dashed var(--f5-background);\n        padding: 5px 12px 6px 8px;\n        background: #fff;\n        border-radius: 12px;\n      }\n\n      .loadingBar {\n        width: 4px;\n        height: calc(100% + 10px);\n        background: transparent;\n        position: absolute;\n        left: 22px;\n        top: 0;\n        z-index: 0;\n        border-right: 2px solid var(--_16c098-background);\n        animation: loadingBar 1.8s ease forwards;\n        animation-delay: calc(var(--index) * .8s);\n        opacity: 0;\n        animation-fill-mode: forwards;\n\n      }\n\n      &:last-child {\n        .loadingBar {\n          display: none;\n        }\n      }\n\n\n\n      .messageAutomateItemListNumber {\n        width: 26px;\n        height: 26px;\n        min-width: 26px;\n        border: 2px dashed var(--_16c098-background);\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        font-weight: 600;\n        color: var(--_16c098-background);\n        background: var(--cdece445-background);\n      }\n\n      .messageAutomateItemListContent {\n        display: flex;\n        justify-content: center;\n        gap: 4px;\n        height: 100%;\n        flex-direction: column;\n        margin: 2px 0px;\n\n        p {\n          font-size: 16px;\n          font-weight: 600;\n          color: var(--black-color);\n          margin: 0px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        span {\n          font-size: 12px;\n          color: var(--595959-color);\n          margin: 0px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .messageAutomateItemListTags {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 10px;\n        margin-left: auto;\n        margin-right: 0px;\n        font-weight: 500;\n        background: var(--16c09829-background);\n        color: var(--_10a37f-background);\n        padding: 5px;\n        border-radius: 11px;\n\n        div {\n          width: 40px;\n          min-width: 40px;\n          max-width: 40px;\n          height: 40px;\n          border-radius: 50%;\n          background-color: var(--f5-background);\n          margin-right: -20px;\n          box-shadow: 0 0 8px -5px var(--black-color);\n        }\n      }\n\n\n\n\n    }\n  }\n\n}\n\n\n/* \n.communitiContainer {\n  flex: 1;\n  position: relative;\n  width: 100%;\n  background: var(--f1-background);\n}\n\n.communiti {\n  all: unset;\n  display: flex;\n  align-items: center;\n  background-color: var(--_16c0982e-background);\n  color: var(--16C097-fill);\n  position: relative;\n  bottom: 0;\n  margin: 0px 0px 58px 0px;\n  border-radius: 9px;\n  padding: 8px 8px 8px 8px;\n  flex: 1 1;\n  font-size: 12px;\n  font-weight: bold;\n  gap: 8px;\n  width: 92%;\n  cursor: pointer;\n\n  svg {\n    width: 20px;\n  }\n\n  &:hover {\n    background-color: var(--f5-background);\n  }\n}\n */\n\n\n.highlightedTextContainer {\n  position: relative;\n  width: 100%;\n}\n\n.highlightedCitation {\n  background-color: rgba(22, 192, 152, 0.1);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.highlightedCitation:hover {\n  background-color: rgba(22, 192, 152, 0.2);\n}\n\n.citationPopup {\n  gap: 20px;\n  transform: translateX(-50%);\n  background: #000000;\n  padding: 12px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  min-width: 200px;\n  max-width: 300px;\n  display: inline-flex;\n}\n\n.citationPopup b {\n  margin: 0px;\n  font-size: 18px;\n  line-height: 24px;\n  color: #fff;\n  min-width: 60%;\n}\n\n.citationPopup a {\n  color: var(--_16c098-background);\n  text-decoration: none;\n  font-size: 12px;\n  line-height: 14px;\n  word-break: break-all;\n  text-align: right;\n}\n\n.citationPopup a:hover {\n  text-decoration: underline;\n}\n\n.dotsContainer {\n  display: flex;\n  gap: 2px;\n  font-size: 30px;\n  font-weight: bold;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  -webkit-background-clip: text;\n  background-clip: text;\n  margin-bottom: -2px;\n  margin-top: -14px;\n}\n\n.dot {\n  animation: jump 1.2s infinite ease-in-out;\n}\n\n.dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes jump {\n\n  0%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.3;\n  }\n\n  50% {\n    transform: translateY(-8px);\n    opacity: 1;\n  }\n}\n\n.profileImage {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 100px;\n}\n\n\n\n.chatRecorder {\n  background: #f4f4f4;\n  border-radius: 12px;\n  padding: 4px 16px;\n  margin-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* width: 100%; */\n  max-width: 600px;\n  margin: 0 auto 10px;\n\n  .chatRecorderPlay {\n    justify-content: flex-end;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    height: 0px;\n\n    button {\n\n      background: #f7f7f7;\n      color: white;\n      border-radius: 50%;\n      padding: 4px 12px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: none;\n      width: 40px;\n      height: 40px;\n      font-size: 20px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      top: -35px;\n      right: -40px;\n      position: relative;\n\n      &:hover {\n        background: #e2e2e2;\n      }\n    }\n  }\n\n  .chatRecorderPlayButton {\n    background: #4caf50;\n    color: white;\n    border-radius: 6px;\n    padding: 4px 12px;\n  }\n\n  .chatRecorderBars {\n    display: flex;\n    align-items: flex-end;\n    height: 40px;\n    width: 100%;\n    gap: 2px;\n    cursor: pointer;\n    user-select: none;\n    margin-bottom: -8px;\n    position: relative;\n  }\n\n  .chatRecorderBarsBar {\n    margin-top: 8px;\n    font-size: 13px;\n    color: #555;\n    margin-left: auto;\n    height: 0px;\n\n    span {\n      position: relative;\n      height: 0px;\n      top: -18px;\n      font-size: 10px;\n      font-weight: 600;\n    }\n  }\n}\n\n.stickyDateSeparator,\n.staticDateLabel {\n  position: sticky;\n  top: 0;\n  background: white;\n  padding: 6px 12px;\n  margin: 0 auto;\n  z-index: 2;\n  /* border-bottom: 1px solid #eee; */\n  width: fit-content;\n\n}\n\n.stickyDateSeparator {\n  position: fixed;\n  top: 55px;\n  left: calc(50% + 138px);\n  /* desplazamiento horizontal */\n  transform: translateX(-50%);\n  /* centrado basado en ancho real */\n  /* width: 150px; */\n  /* background-color: red; */\n}\n\n.staticDateLabel {\n  position: initial;\n  z-index: 2;\n}\n\n.invisibleDateSeparator {\n  height: 1px;\n  opacity: 0;\n}\n\n\n.voiceRecorderContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n\n\n\n.voiceMessageBubble {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 12px 0;\n  background: #fff;\n  border-radius: 12px;\n  padding: 4px 16px;\n  max-width: 600px;\n  min-width: 100px;\n  margin: 0px;\n  position: relative;\n\n  .voiceMessageBubbleTime {\n    position: absolute;\n    left: -15px;\n    bottom: -20px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    button {\n      background: none;\n      border: none;\n      outline: none;\n      cursor: pointer;\n      border: 0;\n      padding: 0px;\n    }\n\n    span {\n      font-size: 10px;\n      color: #575757;\n      min-width: 80px;\n      text-align: left;\n    }\n  }\n}\n\n/* Estilos para el formateo de texto similar a WhatsApp */\n.botMessage .message div {\n\n  /* Estilos para títulos */\n  h1 {\n    font-size: 1.5em;\n    font-weight: bold;\n    margin: 0.5em 0;\n    color: var(--_2-color);\n  }\n\n  h2 {\n    font-size: 16px;\n    font-weight: bold;\n    /* margin: 0.4em 0; */\n    color: var(--_2-color);\n  }\n\n  h3 {\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0.3em 0;\n    color: var(--_2-color);\n  }\n\n  /* Estilos para negrita */\n  b {\n    font-weight: bold;\n  }\n\n  /* Estilos para cursiva */\n  i {\n    font-style: italic;\n  }\n\n  /* Estilos para subrayado */\n  u {\n    text-decoration: underline;\n  }\n\n  /* Estilos para tachado */\n  s {\n    text-decoration: line-through;\n  }\n\n  /* Estilos para código inline */\n  code {\n    background-color: #f1f1f1;\n    padding: 2px 4px;\n    border-radius: 3px;\n    font-family: 'Courier New', monospace;\n    font-size: 0.9em;\n  }\n\n  /* Estilos para bloques de código */\n  pre {\n    border-radius: 5px;\n    padding: 0px;\n    margin: 0px;\n    overflow-x: auto;\n    min-height: 95%;\n\n    code {\n      background: none;\n      padding: 0;\n      border-radius: 0;\n    }\n  }\n\n  /* Saltos de línea */\n  br {\n    display: block;\n    margin: 2px 0;\n  }\n}\n\n.isDoc {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0px !important;\n  background: transparent !important;\n\n  .isDocContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    background: var(--f5-background);\n    border-radius: 10px;\n    border: 1px solid var(--e9e9e9-background);\n    /* margin: 10px 0; */\n    flex-direction: column;\n\n    .docMessage {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex-direction: column;\n      width: 100%;\n      gap: 10px;\n      padding: 0px;\n\n      .docMessageHeader {\n        background: var(--f5-background);\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        gap: 10px;\n        position: sticky;\n        top: 0px;\n        z-index: 1;\n\n        p {\n          margin: 0;\n          font-weight: 500;\n          color: var(--2-color);\n        }\n\n        .viewDocButton {\n          background: #10a37f;\n          color: white;\n          border: none;\n          padding: 8px 16px;\n          border-radius: 6px;\n          cursor: pointer;\n          font-size: 14px;\n          font-weight: 500;\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background: #068a69;\n          }\n        }\n      }\n\n    }\n\n    .docMessageContent {\n      width: 100%;\n      height: 100%;\n      /* background: #fff; */\n      border-radius: 10px;\n      max-height: 130px;\n      overflow: hidden;\n\n      &.docMessageContentShowMore {\n        max-height: unset;\n      }\n\n      /* padding: 10px; */\n    }\n\n    .docMessageShowMore {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      cursor: pointer;\n      width: 100%;\n      transition: all 0.3s ease;\n\n\n      >div {\n        font-size: 12px;\n        font-weight: 500;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 5px;\n        background: var(--f5-background);\n        padding: 2px 10px;\n        border-radius: 10px;\n        border: 1px solid var(--e9e9e9-background);\n        z-index: 9;\n        color: #10a37f;\n\n        svg {\n          width: 10px;\n          height: 10px;\n        }\n      }\n\n      &.docMessageShowMoreShowMore {\n        margin-top: -20px;\n\n        >div {\n          padding: 5px 10px;\n        }\n\n        svg {\n          transform: rotate(180deg);\n        }\n      }\n\n\n      &:after {\n        content: '';\n        position: absolute;\n        width: 95%;\n        height: 2px;\n        background: #10a37f;\n        border-radius: 4px;\n        z-index: 1;\n      }\n\n      &:hover {\n        >div {\n          color: #06785c;\n        }\n\n        svg {\n          color: #06785c;\n        }\n\n        &:after {\n          background: #06785c;\n        }\n      }\n    }\n  }\n\n  .isDocLogs {\n    ul {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      padding: 0px 2px;\n      margin: 0px;\n\n      li {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 10px;\n\n        b {\n          font-size: 12px;\n          font-weight: 500;\n          color: var(--2-color);\n        }\n\n        p {\n          font-size: 14px;\n          font-weight: 600;\n          color: var(--00a3a3-color);\n        }\n      }\n    }\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n:global(.document-container) {\n  max-width: 800px;\n  margin: 0 auto;\n  font-family: 'Arial', sans-serif;\n  line-height: 1.6;\n}\n\n:global(.page) {\n  background: white;\n  /* margin: 0px 0px 20px; */\n  padding: 15px;\n  margin: 0px;\n  border-radius: 8px;\n  /* border: 1px solid #ddd; */\n  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */\n  min-height: 800px;\n  height: 800px;\n  position: relative;\n}\n\n:global(.page-content) {\n  height: 100%;\n  /* margin-bottom: 60px; */\n  white-space: unset;\n  word-wrap: unset;\n\n  >section {\n    height: 100%;\n  }\n}\n\n:global(.page-header) {\n  text-align: center;\n  margin-bottom: 30px;\n  border-bottom: 2px solid #333;\n  padding-bottom: 20px;\n}\n\n:global(.document-title) {\n  color: #2c3e50;\n  margin: 0 0 10px 0;\n  font-size: 2.5em;\n}\n\n:global(.document-subtitle) {\n  color: #7f8c8d;\n  margin: 0;\n  font-size: 1.2em;\n  font-weight: normal;\n}\n\n:global(.header-divider) {\n  border: none;\n  height: 2px;\n  background: linear-gradient(to right, #3498db, #2ecc71);\n  margin: 20px 0;\n}\n\n:global(.page-footer) {\n  position: absolute !important;\n  bottom: 20px;\n  left: 20px;\n  right: 20px;\n}\n\n:global(.footer-divider) {\n  border: none;\n  height: 1px;\n  background: #bdc3c7;\n  margin-bottom: 15px;\n}\n\n:global(.footer-content) {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9em;\n  color: #7f8c8d;\n}\n\n\n:global(.page-break) {\n  page-break-after: always;\n  height: 0;\n  margin: 0;\n  border: 0;\n}\n\n\n.page {\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: #2c3e50;\n    margin-top: 25px;\n    margin-bottom: 15px;\n  }\n\n  p {\n    margin-bottom: 15px;\n    text-align: justify;\n  }\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n  }\n\n  th,\n  td {\n    border: 1px solid #ddd;\n    padding: 12px;\n    text-align: left;\n  }\n\n  th {\n    background-color: #f8f9fa;\n    font-weight: bold;\n  }\n\n  ul,\n  ol {\n    margin: 15px 0;\n    padding-left: 30px;\n  }\n\n  li {\n    margin-bottom: 8px;\n  }\n\n  blockquote {\n    border-left: 4px solid #3498db;\n    margin: 20px 0;\n    padding: 15px 20px;\n    background: #f8f9fa;\n    font-style: italic;\n  }\n\n  code {\n    background: #f1f2f6;\n    padding: 2px 6px;\n    border-radius: 3px;\n    font-family: 'Courier New', monospace;\n  }\n\n  pre {\n    background: #2c3e50;\n    color: #ecf0f1;\n    padding: 15px;\n    border-radius: 5px;\n    overflow-x: auto;\n  }\n}\n\n/* Section Indicator Styles */\n.sectionIndicator {\n  background: var(--white-background);\n  color: var(--black-color);\n  padding: 4px 6px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  transition: all 0.3s ease;\n\n  .sectionInfo {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    .sectionId {\n      font-size: 14px;\n      opacity: 0.9;\n      /* font-family: 'Courier New', monospace; */\n      flex: 1;\n    }\n\n    .sectionActions {\n      display: flex;\n      gap: 4px;\n\n      .sectionActionBtn {\n        background: var(--f5-background);\n        border: none;\n        color: var(--6b7280-color);\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: rgba(255, 255, 255, 0.3);\n          transform: scale(1.05);\n        }\n\n        &:active {\n          transform: scale(0.95);\n        }\n      }\n    }\n  }\n\n  .sectionLogs {\n    ul {\n      list-style: none;\n      padding: 0px;\n      margin: 0px;\n\n      li {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n\n        svg {\n          width: 16px;\n          height: 16px;\n        }\n\n        p {\n          font-size: 12px;\n          font-weight: 500;\n          color: var(--2-color);\n        }\n\n        b {\n          font-size: 12px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n}\n\n.folderIndicatorContainer {\n  margin-bottom: 12px;\n  position: relative;\n  /* z-index: 100; */\n  background: white;\n  border-radius: 8px;\n  animation: slideInFromTop 0.3s ease-out;\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */\n  /* border: 1px solid #e5e7eb; */\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== ESTILOS PARA SCRAPING ===== */\n.scrapingButtonContainer {\n    margin-top: 30px;\n    text-align: center;\n}\n\n.scrapingButton {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    padding: 15px 30px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.scrapingButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.scrapingButton:active {\n    transform: translateY(0);\n}\n\n.scrapingMessage {\n    margin: 20px 0;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 12px;\n    border: 1px solid #e9ecef;\n}\n\n.scrapingMessage .scrapingContainer {\n    max-width: none;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n    box-shadow: none;\n}\n\n/* Responsive para scraping */\n@media (max-width: 768px) {\n    .scrapingButton {\n        padding: 12px 24px;\n        font-size: 14px;\n    }\n    \n    .scrapingMessage {\n        margin: 15px 0;\n        padding: 15px;\n    }\n}\n\n.appIndicatorContainer {\n  margin-bottom: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_PlRt2`,
	"container": `container_oi96Q`,
	"offAsideBar": `offAsideBar_qtpQU`,
	"chatSection": `chatSection_oQ4R_`,
	"inputContainer": `inputContainer_EzQsp`,
	"footerChat": `footerChat_G4Zrl`,
	"languageContainer": `languageContainer_Dhegf`,
	"linksContainerFooterChat": `linksContainerFooterChat_u2H3x`,
	"chatContainer": `chatContainer_p8g34`,
	"messageContainer": `messageContainer_wDfal`,
	"messageSettings": `messageSettings_Cs1Np`,
	"initialMessage": `initialMessage_twsca`,
	"facturaGPTLogo": `facturaGPTLogo_CzcwV`,
	"messageAutomateContainer": `messageAutomateContainer_TwbDa`,
	"chatContainerAgent": `chatContainerAgent_tZLtD`,
	"chatTextContainer": `chatTextContainer_p2EU2`,
	"chatTextContainerEnd": `chatTextContainerEnd_KLmG8`,
	"loading": `loading_mNDYt`,
	"active": `active_ANY5I`,
	"infoChunck": `infoChunck_YD29U`,
	"upArrow": `upArrow_E67l3`,
	"downArrow": `downArrow_CErUu`,
	"chatContainerBorderAnimation": `chatContainerBorderAnimation_YaDoq`,
	"fadeBorder": `fadeBorder_dQAi_`,
	"chatTextAreaContainer": `chatTextAreaContainer_EBubJ`,
	"optionsChat": `optionsChat_i3nml`,
	"activeIcon": `activeIcon_QFgur`,
	"restartButton": `restartButton_lOSBd`,
	"sendMessageBtn": `sendMessageBtn_LdwVt`,
	"ArrowUp": `ArrowUp_Ai_pO`,
	"PauseIcon": `PauseIcon_T_xMC`,
	"errorAlert": `errorAlert_zdTuP`,
	"buttonContainer": `buttonContainer_AZB3h`,
	"message": `message_iTnk6`,
	"avatar": `avatar_JXw7N`,
	"avatarBot": `avatarBot_F9cma`,
	"isApp": `isApp_dnxw0`,
	"appHint": `appHint_uGyor`,
	"isApi": `isApi_RdCbJ`,
	"isAutomate": `isAutomate_iG0_I`,
	"automateVariable": `automateVariable_pQ1v1`,
	"buttonIcon": `buttonIcon_GIymA`,
	"saveButton": `saveButton_O_dVi`,
	"automateCancelled": `automateCancelled_ZiSx1`,
	"automateItem": `automateItem_iwGjw`,
	"automateItemIcon": `automateItemIcon_juCTX`,
	"automateItemContent": `automateItemContent_eXTvY`,
	"isAction": `isAction_Hy6Ka`,
	"big": `big_HO88a`,
	"isImage": `isImage__hR8U`,
	"isTable": `isTable_QKkCl`,
	"messageUserContainer": `messageUserContainer_vFjMA`,
	"botMessage": `botMessage_Q9b72`,
	"optionsBtnMessage": `optionsBtnMessage_efmUB`,
	"userMessage": `userMessage_vPb7Q`,
	"fileContainerMessage": `fileContainerMessage_ca9sn`,
	"iconFileContainer": `iconFileContainer_uyRxh`,
	"userMessageContainer": `userMessageContainer_uOaz9`,
	"date": `date_KFi2T`,
	"messageText": `messageText_ABxYC`,
	"recommendesQuestionsContainer": `recommendesQuestionsContainer_Qz0Dv`,
	"textBlack": `textBlack_FZCNa`,
	"recomendQuestions": `recomendQuestions_FijiG`,
	"chatContainerPage": `chatContainerPage_fsGcO`,
	"hidden": `hidden_ZpbVB`,
	"chatAutomate": `chatAutomate_pPsuZ`,
	"iconContainer": `iconContainer_E_Aug`,
	"fileContainer": `fileContainer_KmZvf`,
	"deleteFileButton": `deleteFileButton_EZmgT`,
	"agentsContainer": `agentsContainer_QpqdD`,
	"dateSeparatorContainer": `dateSeparatorContainer_vkzg7`,
	"lineBreak": `lineBreak_j5B6r`,
	"singleLine": `singleLine_bS42k`,
	"highlight": `highlight_YF1Ot`,
	"replyContainer": `replyContainer_Pzxuy`,
	"viewerSection": `viewerSection_YXLs2`,
	"viewerContainerSearch": `viewerContainerSearch_fFDnV`,
	"viewerContainer": `viewerContainer_ZGkGo`,
	"viewerContainerHeader": `viewerContainerHeader_cZFqM`,
	"viewerContainerAvatar": `viewerContainerAvatar_hGkEu`,
	"viewerContainerInfo": `viewerContainerInfo_thcKg`,
	"viewerContainerStats": `viewerContainerStats_ep4ur`,
	"viewerContainerLabel": `viewerContainerLabel_IxGTS`,
	"viewerContainerLabelBottom": `viewerContainerLabelBottom_NofBJ`,
	"viewerContainerStatus": `viewerContainerStatus_ChCiq`,
	"viewerContainerButtons": `viewerContainerButtons__uIzw`,
	"second": `second_FD511`,
	"viewerContainerButtonsDot": `viewerContainerButtonsDot_kR5Gb`,
	"viewerContainerTags": `viewerContainerTags_VJsjU`,
	"viewerContainerTagsItem": `viewerContainerTagsItem_tBCyt`,
	"viewerContainerActions": `viewerContainerActions_aowL7`,
	"arrobaText": `arrobaText_m3Sz8`,
	"mentionWrapper": `mentionWrapper_zE5BF`,
	"liSinHover": `liSinHover_j8813`,
	"messageDrag": `messageDrag_WfWbM`,
	"backgroundChange": `backgroundChange_TijST`,
	"borderPulse": `borderPulse_uYNtx`,
	"backgroundPulse1": `backgroundPulse1_megnf`,
	"loadingBar": `loadingBar__Y6GE`,
	"messageDragContainer": `messageDragContainer_GltQd`,
	"messageDragAgent": `messageDragAgent_NtVHn`,
	"messageDragAgentItemClose": `messageDragAgentItemClose_tMcQh`,
	"loadedAgent": `loadedAgent_a0Ovh`,
	"messageDragAgentItem": `messageDragAgentItem_GYhuJ`,
	"messageDragAgentItemHeader": `messageDragAgentItemHeader_JV0Aa`,
	"messageDragAgentItemHeaderTags": `messageDragAgentItemHeaderTags_V4fd6`,
	"messageDragAgentItemHeaderIcon": `messageDragAgentItemHeaderIcon_AZ2J7`,
	"messageDragAgentItemHeaderContent": `messageDragAgentItemHeaderContent_QOTPt`,
	"messageDragAgentItemList": `messageDragAgentItemList_p2IsS`,
	"messageDragAgentItemListNumber": `messageDragAgentItemListNumber_GxgQw`,
	"loadingMessage": `loadingMessage_xWfaI`,
	"messageDragAgentItemAlert": `messageDragAgentItemAlert_Gq1q7`,
	"messageDragAgentItemAlertTags": `messageDragAgentItemAlertTags_qA2sx`,
	"messageDragAgentItemAlertTag": `messageDragAgentItemAlertTag_LkhOr`,
	"messageDragAgentItemAlertButtons": `messageDragAgentItemAlertButtons_V4pmM`,
	"importButton": `importButton_yFwcW`,
	"messageDragAgentItemHeaderTagsLabel": `messageDragAgentItemHeaderTagsLabel_Bo_O3`,
	"showList": `showList_gyCj3`,
	"isLoading": `isLoading_d80DB`,
	"messageDragAgentItemListContainer": `messageDragAgentItemListContainer_eiN18`,
	"messageDragAgentItemListContent": `messageDragAgentItemListContent_RBmeY`,
	"messageDragAgentItemListTags": `messageDragAgentItemListTags_rbKKn`,
	"pending": `pending_UfAcD`,
	"messageDragAttachment": `messageDragAttachment_szNi7`,
	"messageAutomateItem": `messageAutomateItem_PM_Jn`,
	"messageAutomateItemHeader": `messageAutomateItemHeader_GSmtj`,
	"messageAutomateItemHeaderIcon": `messageAutomateItemHeaderIcon_ZNsul`,
	"messageAutomateItemHeaderContent": `messageAutomateItemHeaderContent_AUK8E`,
	"messageAutomateItemHeaderTags": `messageAutomateItemHeaderTags_LH7as`,
	"messageAutomateItemHeaderTagsLabel": `messageAutomateItemHeaderTagsLabel_vrRUV`,
	"messageAutomateItemList": `messageAutomateItemList_EWN5K`,
	"messageAutomateItemListContainer": `messageAutomateItemListContainer_nO5_i`,
	"messageAutomateItemListNumber": `messageAutomateItemListNumber_IapU7`,
	"messageAutomateItemListContent": `messageAutomateItemListContent_s91ND`,
	"messageAutomateItemListTags": `messageAutomateItemListTags_Iep29`,
	"highlightedTextContainer": `highlightedTextContainer_hB2Lb`,
	"highlightedCitation": `highlightedCitation_fn9op`,
	"citationPopup": `citationPopup_wPIYC`,
	"dotsContainer": `dotsContainer_RajZe`,
	"dot": `dot_n_P6L`,
	"jump": `jump_HI9Ht`,
	"profileImage": `profileImage_WPUT8`,
	"chatRecorder": `chatRecorder_XR6j6`,
	"chatRecorderPlay": `chatRecorderPlay_WKxL5`,
	"chatRecorderPlayButton": `chatRecorderPlayButton_ksVq7`,
	"chatRecorderBars": `chatRecorderBars_reCJJ`,
	"chatRecorderBarsBar": `chatRecorderBarsBar_yb4oC`,
	"stickyDateSeparator": `stickyDateSeparator_XWGG2`,
	"staticDateLabel": `staticDateLabel_zR6EM`,
	"invisibleDateSeparator": `invisibleDateSeparator_QGKVQ`,
	"voiceRecorderContainer": `voiceRecorderContainer_XzFZ3`,
	"voiceMessageBubble": `voiceMessageBubble_WaXwT`,
	"voiceMessageBubbleTime": `voiceMessageBubbleTime_GXfME`,
	"isDoc": `isDoc_orTIj`,
	"isDocContainer": `isDocContainer_qGjtN`,
	"docMessage": `docMessage__lz98`,
	"docMessageHeader": `docMessageHeader_bXGYg`,
	"viewDocButton": `viewDocButton_A_QZg`,
	"docMessageContent": `docMessageContent_X8Ng3`,
	"docMessageContentShowMore": `docMessageContentShowMore_ombBN`,
	"docMessageShowMore": `docMessageShowMore_yQcYo`,
	"docMessageShowMoreShowMore": `docMessageShowMoreShowMore_McA9d`,
	"isDocLogs": `isDocLogs_aVoU3`,
	"page": `page_LRvzK`,
	"sectionIndicator": `sectionIndicator_dLHci`,
	"sectionInfo": `sectionInfo_BeuEj`,
	"sectionId": `sectionId_fS3Lr`,
	"sectionActions": `sectionActions_zLkGV`,
	"sectionActionBtn": `sectionActionBtn_C8VVq`,
	"sectionLogs": `sectionLogs_KeNM0`,
	"folderIndicatorContainer": `folderIndicatorContainer_CATE_`,
	"slideInFromTop": `slideInFromTop_DPrIH`,
	"scrapingButtonContainer": `scrapingButtonContainer_OK_WS`,
	"scrapingButton": `scrapingButton_tmrtb`,
	"scrapingMessage": `scrapingMessage_j0SKW`,
	"scrapingContainer": `scrapingContainer_epryS`,
	"appIndicatorContainer": `appIndicatorContainer_ZxHwg`,
	"rogBgImg": `rogBgImg_sSKSz`
};
export default ___CSS_LOADER_EXPORT___;
